/* eslint-disable no-unused-vars, jsx-a11y/anchor-is-valid, jsx-a11y/alt-text, eqeqeq, react-hooks/exhaustive-deps, no-dupe-keys */
import react, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useTranslation, Trans } from 'react-i18next';
import { sprintf } from "sprintf-js";
import { useHistory } from "react-router-dom";

import Sidebar from '../Sidebar/Sidebar.jsx';
import HeaderNoDropdown from '../Header/HeaderNoDropdown.jsx';
import { MyBooking } from "../apiUtils.jsx";

import greenRoom from "../../assets/images/icons/green-room.svg";
import greenChair from "../../assets/images/icons/green-chair.svg";
import greenCar from "../../assets/images/icons/green-car.svg";
import NodataCalendar from "../../assets/images/icons/nodata-calendar.png";
import logo from "../../assets/images/logo-big.svg";
import close from "../../assets/images/icons/close.svg";
import GreenMapIcon from "../../assets/images/icons/green-map-icon.svg";
import TimeIcon from "../../assets/images/icons/time.svg";
import UserIcon from "../../assets/images/icons/user-icon.svg";
import CheckOutIcon from "../../assets/images/icons/checkin-checkout.svg";
import Exclamation from "../../assets/images/icons/exclamation-circle.svg";

import CustomSearchableDropdown from "../Common/CustomSearchableDropdown.jsx";
import NotificationMessage from "../Common/NotificationMessage.jsx";
import NewMeetingModal from "../Common/NewMeetingModal.jsx";
import SpotTags from "../Common/SpotTags.jsx";
import DatePicker from "react-datepicker";
import {
  delay, formatDate, getWeekKey, getBookingDateStr, formatDateToEEEddMMM, getCurrentDateTime,
  formatDateYYYYMMDD, toSafeFloat, formatReactString, getDisplayRefundCreditValue, parseLocalDate
} from "../../utils/CommonUtils.js";
import { getMakeInvitations, setMakeInvitations } from "../../utils/SecurityService.js";

import { Images } from "../Common/Images.jsx"

import {
  CancelBooking_api, ReportParkingViolation_api, GetAlternateParkingSpot_api, CancelMeeting_api, DeclineMeeting_api,
  RescheduleMeeting_api, CheckInUser_api
} from "../WeeklyCalendar/WeeklyCalendarAPI.jsx"

import { handleApiResponse } from "../../hooks/notificationHelper.js";
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";
import {
  CheckInForGuestUser_api, HomeScreenBookings_api, InvitationGuestBookings_api,
  ReportParkingViolationForGuest_api, GetAlternateParkingSpotForGuest_api
} from "./MyBookingAPI.jsx";
import { LargeTitle } from "@fluentui/react-components";
import CreditInfoCard from "../Common/CreditInfoCard.jsx";
import NotificationPanel from "../Common/Notification.jsx";

export default function Booking() {
  const getFirstName = () => localStorage.getItem("firstname");
  const { t } = useTranslation("common");
  const { i18n } = useTranslation();
  const locale = i18n.language.split("-")[0];
  const history = useHistory();
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const bookingTableBodyRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const [totalBookings, setTotalBookings] = useState(0);
  const [userCredit, setUserCredit] = useState(0);
  const [creditSystemStatus, setCreditSystemStatus] = useState(0);
  const [zoneCreditValue, setZoneCreditValue] = useState(0);
  const [creditBalanceRefill, setCreditBalanceRefill] = useState(0);
  const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
  const [companyId, setCompanyId] = useState(0);
  const [allowInvitations, setAllowInvitations] = useState(Number(getMakeInvitations()) === 1);

  const [showPostEventModal, setShowPostEventModal] = useState(false);
  const [showMyInvitationEventModal, setShowMyInvitationEventModal] = useState(false);
  const [selectedBookingType, setSelectedBookingType] = useState(0);

  const [selectedDay, setSelectedDay] = useState(null);
  const [UserName, setUserName] = useState(localStorage.getItem("firstname") + " " + localStorage.getItem("lastname"));
  const [holidays, setHolidays] = useState([]);
  const [mapAvailable, setMapAvailable] = useState(null);
  const [mapAvailableType, setMapAvailableType] = useState(null);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [clickedFullDay, setClickedFullDay] = useState(null);
  const [spotTagList, setSpotTagList] = useState([]);

  const [open, setOpen] = useState(true);

  //Edit Meeting (RON-5375) — reuse NewMeetingModal in edit mode
  const [showEditMeetingModal, setShowEditMeetingModal] = useState(false);
  const [editRescheduleType, setEditRescheduleType] = useState(2); // 2 = this event, 1 = whole series, 3 = this and following

  //Reschedule Meeting
  const [showRescheduleMeetingModal, setShowRescheduleMeetingModal] = useState(false);
  const [selectedRescheduleDate, setSelectedRescheduleDate] = useState("");
  const [showReScheduleMeetingDateSelectModal, setShowReScheduleMeetingDateSelectModal] = useState(false);
  const [rescheduledBookingOccurrence, setRescheduledBookingOccurrence] = useState(1);

  //handle Cancel Meeting
  const [showCancelMeetingModal, setShowCancelMeetingModal] = useState(false);
  const [showCancelMeetingDateSelectModal, setShowCancelMeetingDateSelectModal] = useState(false);

  //handle Decline Meeting
  const [showDeclineMeetingModal, setShowDeclineMeetingModal] = useState(false);
  const [showDeclineMeetingDateSelectModal, setShowDeclineMeetingDateSelectModal] = useState(false);

  //handle Cancel Booking
  const [cancelBookingSpotId, setCancelBookingSpotId] = useState(null);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  //handle SpotTakenConfirmation
  const [showReportParkingViolationModal, setShowReportParkingViolationModal] = useState(false);
  const [showAlternateParkingSpotModal, setShowAlternateParkingSpotModal] = useState(false);
  const [parkingViolationReportingData, setParkingViolationReportingData] = useState(false);

  //handle SpotTakenConfirmation for My Invitation
  const [showReportParkingViolationModalForInv, setShowReportParkingViolationModalForInv] = useState(false);
  const [showAlternateParkingSpotModalForInv, setShowAlternateParkingSpotModalForInv] = useState(false);
  const [parkingViolationReportingDataForInv, setParkingViolationReportingDataForInv] = useState(false);

  const [notification, setNotification] = useState(null);
  const [repeatOption, setRepeatOption] = useState("0");
  const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

  const bookingTypeOptions = [
    { id: 0, name: t("react_my_bookings") },
    { id: 1, name: t("react_my_invitations") },
  ];
  const [bookingType, setBookingType] = useState(0);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const expandedLogoUrl = companyId
    ? `https://ronlivestaging.s3.amazonaws.com/companylogo/${companyId}/logo.png`
    : "";

  const getBookingDetailsText = (booking) => {
    if (bookingType === 1) {
      return [booking?.GuestUserFirstName, booking?.GuestUserLastName]
        .filter(Boolean)
        .join(" ")
        .trim();
    }

    return booking?.MeetingName;
  };


  const isHolidayInList = (date) => {
    const holidays = selectedEvent?.HolidaysZoneWise || [];
    return holidays.includes(formatDateYYYYMMDD(date));
    //console.log("holidays from isHolidayInList")
  };

  const fetchData = async (pageNumber) => {
    if (isPageLoading) return;

    if (pageNumber === 1) {
      setIsInitialLoading(true);
    } else {
      setIsPageLoading(true);
    }

    try {
      const res = (bookingType === 0)
        ? await HomeScreenBookings_api({ Page: pageNumber })
        : await InvitationGuestBookings_api({ Page: pageNumber });

      const records = res?.Data?.Records?.BookingList || {};

      const upcoming = records?.UpcomingBooking || [];
      const today = records?.CurrentBooking || [];
      const totalBookingsFromApi = Number(records?.Totalbookingcount) || 0;
      setUserCredit(res?.Data?.Credit);
      setCreditSystemStatus(res?.Data?.CreditSystemStatus ?? 0);
      setZoneCreditValue(res?.Data?.ZoneCreditValue || 0);
      setCreditBalanceRefill(res?.Data?.CreditBalanceRefillEvery);
      setIsThumbnailPresent(res?.Data?.IsThumbnailPresent);
      setCompanyId(res?.Data?.CompanyId ?? res?.Data?.CompanyID ?? 0);
      if (res?.Data?.MakeInvitations !== undefined && res?.Data?.MakeInvitations !== null) {
        const makeInvitationsValue = Number(res.Data.MakeInvitations);
        setAllowInvitations(makeInvitationsValue === 1);
        setMakeInvitations(makeInvitationsValue);
      }

      const totalPagesFromApi =
        Number(records?.TotalPagesForUpcomingBooking) || 1;

      console.log("TOTAL PAGES FROM API:", totalPagesFromApi);

      setTotalPages(totalPagesFromApi);
      setTotalBookings(totalBookingsFromApi);

      // ⭐ PAGE BASED MERGE
      const bookingsToMerge =
        pageNumber === 1 ? [...today, ...upcoming] : [...upcoming];

      // ⭐ SORT
      bookingsToMerge.sort((a, b) => {
        const dateA = new Date(
          a.BookingDate + " " + (a.BookingStartTime || "00:00")
        );
        const dateB = new Date(
          b.BookingDate + " " + (b.BookingStartTime || "00:00")
        );
        return dateA - dateB;
      });

      if (pageNumber === 1) {
        setBookingData(bookingsToMerge);
        setHasMore(totalPagesFromApi > 1);
      } else {
        setBookingData((prev) => [...prev, ...bookingsToMerge]);
      }

      if (pageNumber >= totalPagesFromApi) {
        setHasMore(false);
      }

      if (res?.Data?.ResponseCode != 416) {
        handleApiUiResponse(res, {
          successToaster: 0,
          errorToaster: 1,
          alertPopup: 1
        });
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setIsInitialLoading(false);
      setIsPageLoading(false);
    }
  };

  const handleTableScroll = () => {
    const tableBody = bookingTableBodyRef.current;

    if (!tableBody || isInitialLoading || isPageLoading || !hasMore) return;

    const reachedBottom =
      tableBody.scrollTop + tableBody.clientHeight >= tableBody.scrollHeight - 24;

    if (!reachedBottom) return;

    setPage((prev) => {
      if (prev < totalPages) {
        return prev + 1;
      }

      return prev;
    });
  };

  useEffect(() => {
    document.title = `${t("react_home")} | Ronspot`
  }, []);


  useEffect(() => {
    if (page === 1) return; // page 1 already loaded

    fetchData(page);
  }, [page]);

  useEffect(() => {
    setPage(1);
    setBookingData([]);
    setHasMore(true);
    fetchData(1);
  }, [bookingType]);

  useEffect(() => {
    if (!allowInvitations && bookingType !== 0) {
      setBookingType(0);
    }
  }, [allowInvitations, bookingType]);


  const createEventFromBooking = (booking) => {
    if (!booking) return null;

    console.log("bookingData from createEventFromBooking-", booking);

    return {
      zoneId: booking.ZoneId,
      zoneName: booking.ZoneName,
      zoneType: booking.ZoneType,
      zoneCurrentDateTime: booking.ZoneCurrentDateTime,

      spotId: toSafeFloat(booking.SpotId),
      spotId: toSafeFloat(booking.SpotId),
      spotName: booking.SpotName,
      spotType: booking.SpotType,
      spotTagList: (booking.SpotTagList || []).map(tag => ({
        Id: tag.id,
        TagName: tag.tagName
      })),

      spotTagList: (booking.SpotTagList || []).map(tag => ({
        Id: tag.id,
        TagName: tag.tagName
      })),


      userId: booking.UserId,
      organiserId: booking.OrganiserId,
      organiserName: booking.OrganiserName,

      bookingDate: booking.BookingDate,
      bookingStartTime: booking.BookingStartTime,
      bookingEndTime: booking.BookingEndTime,
      isHourlyBooking: booking.IsHourlyBooking,
      bookingPeriod: booking.IsHourlyBooking === 1 ? 2 : 1,

      queuePosition: booking.QueuePosition,
      queuePositionStatus: booking.QueuePositionStatus,

      credit: booking.Credit,
      zoneCreditValue: booking.ZoneCreditValue,
      individualDayCost: booking.IndividualDayCost,
      fullRefundCredit: booking.FullRefundCredit,
      halfRefundCredit: booking.HalfRefundCredit,
      noRefundCredit: booking.NoRefundCredit,
      refundStartDateTime: booking.RefundStartDateTime,
      refundEndDateTime: booking.RefundEndDateTime,

      mapExist: booking.MapExist,
      mapType: booking.MapType,

      checkInFlag: booking.CheckInFlag,
      checkInType: booking.CheckInType || [],
      checkInLevelType: booking.CheckInLevelType,

      isMeeting: booking.IsMeeting,
      meetingId: booking.MeetingId,
      meetingName: booking.MeetingName,
      meetingApproveStatus: booking.MeetingApproveStatus,
      isApproversExist: booking.IsApproversExist,
      showApproverDate: booking.ShowApproverDate,
      isApprover: booking.IsApprover,
      participants: booking.Participants,
      startDate: booking.StartDate,
      repeatOption: booking.RepeatOption,
      repeatOptionDay: booking.RepeatOptionDay,
      meetingRepeat: booking.MeetingRepeat,
      weeklyRepeatOptionDay: booking.WeeklyRepeatOptionDay,
      monthlyRepeatOptionWeekDay: booking.MonthlyRepeatOptionWeekDay,

      showReportLabel: booking.ShowReportLabel,
      disablePastBooking: booking.DisablePastBooking,
      note: booking.Note,
      guid: booking.GuId,
      lastDateOfBookingAvailable: booking.LastDateOfBookingAvailable,
      selectedDays: booking.SelectedDays || [],
      timeIntervals: booking.TimeIntervals || [],

      // My Invitations specific parameters- start
      guestUserFirstName: booking.GuestUserFirstName,
      guestUserLastName: booking.GuestUserLastName,
      guestUserId: booking.GuestUserId,
      // My Invitations specific parameters- end
    };
  };

  const [selectedEvent, setSelectedEvent] = useState(null);

  // const selectedZoneCreditValue = useMemo(() => {
  //   if (selectedEvent?.zoneCreditValue !== undefined && selectedEvent?.zoneCreditValue !== null) {
  //     return String(selectedEvent.zoneCreditValue);
  //   }
  //
  //   const selectedBooking = bookingData.find(
  //     (booking) => String(booking.ZoneId) === String(selectedZoneId)
  //   );
  //
  //   return String(selectedBooking?.ZoneCreditValue ?? "0");
  // }, [selectedEvent, bookingData, selectedZoneId]);

  const handleRowClick = (booking) => {
    console.log("booking from handleRowClick", booking)
    setHolidays(booking.HolidaysZoneWise || []);

    const eventObj = createEventFromBooking(booking);
    console.log("eventObj from handleRowClick", eventObj);
    setSelectedEvent(eventObj);
    ShowHideModels(true);
  };

  // My Booking UI Component - Start here ...
  const PostEventModal = ({ onClose }) => {

    const {
      // -------- Basic Info --------
      zoneId,
      zoneName,
      zoneType,
      zoneCurrentDateTime,

      spotId,
      spotName,
      spotType,
      spotTagList = [],

      // -------- User Info --------
      userId,
      organiserId,
      organiserName,

      // -------- Booking Date/Time --------
      bookingDate,
      bookingStartTime,
      bookingEndTime,
      isHourlyBooking,
      bookingPeriod,

      // -------- Queue --------
      queuePosition,
      queuePositionStatus,

      // -------- Credit Info --------
      credit,
      zoneCreditValue,
      individualDayCost,
      fullRefundCredit,
      halfRefundCredit,
      noRefundCredit,
      refundStartDateTime,
      refundEndDateTime,

      // -------- Map --------
      mapExist,
      mapType,

      // -------- Check-In --------
      checkInFlag,
      checkInType = [],
      checkInLevelType,

      // -------- Meeting --------
      isMeeting,
      meetingId,
      meetingName,
      meetingApproveStatus,
      isApproversExist,
      isApprover,
      participants,
      startDate,
      // -------- Repeat --------
      repeatOption,
      repeatOptionDay,
      meetingRepeat,
      weeklyRepeatOptionDay,
      monthlyRepeatOptionWeekDay,

      // -------- Extra --------
      showReportLabel,
      disablePastBooking,
      note,
      guid,
      lastDateOfBookingAvailable,
      selectedDays = [],
      timeIntervals = []

    } = selectedEvent || {};

    const bookingDateStr = bookingDate;
    console.log("selectedEvent---", selectedEvent, spotId)
    const { displayMonth, displayYear } =
      useBookingDisplayDate(bookingDateStr, setSelectedDay);

    useEffect(() => {
      setMapAvailable(mapExist);
      setMapAvailableType(mapType);
      setRepeatOption(repeatOption);
      setSelectedZoneId(zoneId);
      setClickedFullDay(bookingDate);
      setSpotTagList(spotTagList);
    }, [mapExist, mapType, repeatOption, zoneId, bookingDate]);

    const hasBookingDate = Boolean(bookingDateStr);

    //const isHourlyBooking = spotType === 3 || bookingPeriod === 2;

    const hasTime = bookingStartTime && bookingEndTime;

    const hasNoTime = !bookingStartTime && !bookingEndTime;

    const showLeaveQueue = toSafeFloat(spotId) === -1;

    const isCheckIn = (checkInType.length > 0 && (checkInType.includes(2)) && spotId >= 0 && (checkInFlag === 0 || checkInFlag === 2));
    //console.log("isCheckIn--->", isCheckIn, checkInType, spotId, checkInFlag);
    const showCheckOut = checkInType.includes(0) ? false : true;

    const isSpotType3 = isMeeting === 1;
    /* console.log("isSpotType3, meetingName, organiserName,bookingStartTime,      bookingEndTime,hasTime,isHourlyBooking --->", isSpotType3, meetingName, organiserName, bookingStartTime,
      bookingEndTime, hasTime, isHourlyBooking); */
    //console.log("queuePosition-->", queuePosition);
    const isOrganiserEqualUser = organiserId === userId;
    const hasApprovers = isApproversExist === 1;

    const canRescheduleByApproval =
      meetingApproveStatus === 0 ||
      meetingApproveStatus === 5 ||
      (isApprover === 1 && meetingApproveStatus === 1);
    let showCancelButton = true;

    let showRescheduleButton = false;
    let showDeclineButton = false;

    //if (totalBookings > 0) { showCancelButton = true; }
    if (showLeaveQueue) { showCancelButton = false; }

    if (isSpotType3) {

      if (!isOrganiserEqualUser) {         // OrganiserId != UserId

        showCancelButton = false;
        showRescheduleButton = false;
        showDeclineButton = true;

      } else {                            // OrganiserId == UserId

        showDeclineButton = false;
        showCancelButton = true;

        if (hasApprovers) {
          showRescheduleButton = canRescheduleByApproval;
        } else {
          showRescheduleButton = true;
        }
      }
    }

    let showSpaceTakenButton = false;

    const today = new Date().toISOString().split("T")[0];

    if (
      //showLeaveQueue === false && showReportLabel === 1 &&       bookingDate === today
      toSafeFloat(spotId) > 0 && zoneType === 1 && showReportLabel === 1 && bookingDate === today
    ) {
      showSpaceTakenButton = true;
    }
    //console.log("totalBookings--->", totalBookings);


    /*let titleText = "";
     if (showLeaveQueue) {
      if (queuePosition === 0)
        titleText = t("react_you_are_on_waitlist");
      else
        titleText = `${t("react_you_are_in_position")} ${queuePosition}`;
    }
    else if (!showLeaveQueue || (zoneType === 2 && isSpotType3 && !isOrganiserEqualUser)) {
      titleText = t("YourBookingForSpace") + " " + spotName;
    }
    else if (zoneType === 2 && isSpotType3 && isOrganiserEqualUser) {
      titleText = t("react_invited_for") + " " + spotName;
    }
    else {
      titleText = t("YourBookingForSpace") + " " + spotName;
    } */
    let titleText = "";

    if (showLeaveQueue) {
      if (queuePosition === 0)
        titleText = t("react_you_are_on_waitlist");
      else {
        titleText = formatReactString(t("react_waiting_position"), [queuePosition], {
          defaultRenderer: (val, type, index) => (
            <span key={`waiting-position-${index}`} className="color-dark-black">{val}</span>
          )
        });
      }
    }
    else if (!showLeaveQueue || (zoneType === 2 && isSpotType3 && !isOrganiserEqualUser)) {

      titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
        defaultRenderer: (val, type, index) => (
          <span key={`booking-space-${index}`} className="color-dark-black">{val}</span>
        )
      });
    }
    else if (zoneType === 2 && isSpotType3 && isOrganiserEqualUser) {
      titleText = formatReactString(t("react_invited_for"), [spotName], {
        defaultRenderer: (val, type, index) => (
          <span key={`invited-for-${index}`} className="color-dark-black">{val}</span>
        )
      });
    }
    else {

      titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
        defaultRenderer: (val, type, index) => (
          <span key={`booking-space-${index}`} className="color-dark-black">{val}</span>
        )
      });
    }

    const repeatIcon = useMemo(() => {
      if (!repeatOption) return null;          // "" or undefined → no icon
      if (repeatOption === "0") return Images.TimeIcon;

      return Images.RepeatEventClock;          // repeat clock icon
    }, [repeatOption]);

    // Credit refund 
    const displayCreditValue = getDisplayRefundCreditValue({
      refundStartDateTime,
      refundEndDateTime,
      zoneCurrentDateTime,
      fullRefundCredit,
      halfRefundCredit,
      noRefundCredit
    });

    const isZeroDisplayCredit =
      displayCreditValue === 0 || displayCreditValue === "0";

    /* -------------------- ACTION BUTTONS -------------------- */

    // Shared by renderActionButtons and the button count, so the two cannot drift.
    const showCheckOutButton =
      !isCheckIn && showCheckOut && spotId >= 0 &&
      Array.isArray(checkInType) && checkInType.length > 0 && checkInFlag === 1;
    const showGoToMapButton = mapExist === 1 && mapType !== 1;

    // EditMeetingButtons renders 1 button, or 3 for a series (meetingRepeat > 0) - but
    // "Edit this and all following events" is d-none until the API supports
    // RescheduleType 3, so a series shows 2 for now. Restore 3 when removing that d-none.
    const editMeetingButtonCount = showRescheduleButton ? (meetingRepeat > 0 ? 2 : 1) : 0;
    const actionButtonCount =
      [isCheckIn, showCheckOutButton, showSpaceTakenButton, showGoToMapButton,
        showLeaveQueue, showDeclineButton, showCancelButton === true]
        .filter(Boolean).length + editMeetingButtonCount;

    const renderActionButtons = () => {
      //console.log("mapAvailable,  mapAvailableType,  bookingForModal?.DeskAvailable ,  bookingForModal?.MeetingRoomAvailable, zoneCreditValue, individualDayCost ===",
      //    mapAvailable, mapAvailableType, bookingForModal?.DeskAvailable, bookingForModal?.MeetingRoomAvailable, zoneCreditValue, individualDayCost);
      //console.log("showReportLabel,showLeaveQueue at renderActionButtons->", showReportLabel, showLeaveQueue);

      //if (!bookingForModal) return null;
      console.log("Post Event Modal Testing")
      //console.log("meetingRoomAvailable of posteventmodal-", meetingRoomAvailable)
      return (
        <>
          {/* Check In Button */}
          {/* Only for Today's Booking - After booking conditions */}
          {isCheckIn && (
            <CheckInButton zoneId={zoneId} checkInFlag={1} CheckInDate={getCurrentDateTime()} spotId={spotId} />
          )}
          {/* Check Out Button */}
          {showCheckOutButton && (
            <CheckOutButton zoneId={zoneId} checkInFlag={2} CheckInDate={getCurrentDateTime()} spotId={spotId} />
          )}
          {/* Space taken button*/}
          {showSpaceTakenButton && (
            <SpotTakenButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} />
          )}
          {/* GoTo Map Button */}
          {showGoToMapButton && (
            <GoToMapButton zoneId={zoneId} bookingDateStr={bookingDateStr} />
          )}
          {showLeaveQueue && (
            <LeaveQueButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} spotId={spotId} />
          )}
          {/*Decline Button*/}
          {showDeclineButton && (
            <DeclineButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} BookingId={meetingId} />
          )}
          {/*Edit meeting buttons (RON-5375) — replaces the old single Reschedule button */}
          {showRescheduleButton && (
            <EditMeetingButtons meetingRepeat={meetingRepeat} />
          )}
          {/*Cancel Booking Button */}    {/*SHOW Cancel Booking when condition is FALSE */}
          {showCancelButton === true && (
            <CancelBookingButton zoneId={zoneId} bookingDateStr={bookingDateStr} meetingId={meetingId} />
          )}

        </>
      );
    }

    /* -------------------- JSX -------------------- */

    return (
      <div
        className={`modal ctm-modalscroll-modal${actionButtonCount > 3 ? " ctm-space-modal" : ""}`}
        style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
        id="dateModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered modal-custom-width">
          <div className="modal-content modal-radius">
            <div className="modal-body">
              <div className="ctm-modal-header">
                <div className="close-modal">
                  <a onClick={onClose}>
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>

                <div className="pt-4">
                  <h5 className="popup-title pb-0">{titleText}</h5>
                </div>

                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                  <div className="selected-current-date">
                    <span>{selectedDay}</span>
                    <span>{t(displayMonth)} {displayYear}</span>
                  </div>
                  {/* Show CREDIT */}
                  {(zoneCreditValue > 0 && !isSpotType3) && (
                    <div className="credit-info">
                      <a
                        href="#"
                        className="orange-outline-with-icon"
                        onClick={(e) => e.preventDefault()}
                      >
                        {isZeroDisplayCredit ? (
                          <>
                            <img src={Images.GrayStar} alt="star" className="img-fluid" />
                            <span>{displayCreditValue}</span>
                          </>
                        ) : (
                          <>
                            <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                            <span>
                              {`+${displayCreditValue}`}
                            </span>
                          </>
                        )}
                      </a>
                    </div>
                  )}
                </div>

                <div className="divider-line mt-3"></div>
              </div>
              <div className="modal-des">
                <div className="modal-scroll-inner">
                  <div className="icon-with-list">
                    <div className="icon-wrap">
                      <img src={Images.ZoneMap} alt="map" />
                      <h4>{zoneName}</h4>
                    </div>
                    {bookingDate !== "" && (
                      <>
                        {(isSpotType3 || bookingPeriod === 2) ? (
                          <>
                            {/* Start & End time exist */}
                            {bookingStartTime !== "" && bookingEndTime !== "" ? (
                              <>
                                <div className="icon-wrap">
                                  {repeatIcon && <img src={repeatIcon} alt="repeat" className="img-fluid" />}
                                  <h4>
                                    {bookingStartTime} - {bookingEndTime},{" "}
                                    <span>{formatDateToEEEddMMM(bookingDate)}</span>
                                  </h4>
                                </div>

                                {/* Show organizer ONLY if SpotType === 3 */}
                                {isSpotType3 && organiserName && (
                                  <div className="icon-wrap meeting-icon">
                                    <h4 className="ps-3 ms-3">{meetingName} <span>({organiserName})</span></h4>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="icon-wrap">
                                {repeatIcon && <img src={repeatIcon} alt="repeat" className="img-fluid" />}
                                <h4>
                                  {formatDateToEEEddMMM(bookingDate)}
                                </h4>
                              </div>
                            )}
                          </>
                        ) : (
                          /* Not hourly → All day */
                          <div className="icon-wrap">
                            {repeatIcon && <img src={repeatIcon} alt="repeat" className="img-fluid" />}
                            <h4>
                              {t("all_day")} <span>{formatDateToEEEddMMM(bookingDate)}</span>
                            </h4>
                          </div>
                        )}
                      </>
                    )}
                    {/* {!meetingName && ( */}
                    <div className="icon-wrap">
                      <img src={Images.Participant} className="img-fluid" />
                      <h4>{UserName}</h4>
                    </div>
                    {/* )} */}

                    {/* {spotTagList && (
                    <div>
                      <SpotTags spotTagList={spotTagList} />
                    </div>
                  )
                  } */}
                  </div>
                </div></div>
              <div className="ctm-modal-footer">
                {renderActionButtons()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const CheckInButton = ({ checkInFlag, zoneId, CheckInDate, spotId }) => (
    <div className="d-flex justify-content-between align-items-center gap-3">
      <div className="d-block w-100">
        <a
          href="#"
          onClick={(e) => {
            if (isLoading) return;
            e.preventDefault();
            if (!isLoading) {
              ShowHideModels(false);
              checkIncheckOut(checkInFlag, zoneId, CheckInDate, spotId)
            }
          }}
          className="fc-checkInBtn-button w-100 fc-checkInBtn-img">
          <img src={Images.CheckInIcon} className="img-fluid"></img>
          <span>{t("react_check_in")}</span>
        </a>
      </div>
    </div>
  );
  const CheckOutButton = ({ checkInFlag, zoneId, CheckInDate, spotId }) => (
    <div classname="d-flex justify-content-between align-items-center gap-3">
      <div className="d-block w-100">
        <a
          href="#"
          onClick={(e) => {
            if (isLoading) return;
            e.preventDefault();
            if (!isLoading) {
              ShowHideModels(false);
              checkIncheckOut(checkInFlag, zoneId, CheckInDate, spotId);
            }
          }}
          className="fc-checkInBtn-button fc-button fc-button-primary active w-100 fc-checkInBtn-img"
        >
          <img src={Images.CheckInIcon} className="img-fluid"></img>
          <span>{t("react_check_out")}</span>
        </a>
      </div>
    </div>
  );
  const LeaveQueButton = ({ zoneId, bookingDateStr, spotId }) => (

    <a
      href="#"
      onClick={async (e) => {
        e.preventDefault();
        if (!isLoading) {
          ShowHideModels(false);
          await CancelBooking(
            zoneId,
            bookingDateStr,
            spotId
          );
        }
      }}
      className="green-outline-with-icon w-100 mw-100 min-height-56"
    ><img src={Images.UserInQue} className="img-fluid"></img>
      <span>{t("react_leave_waitlist")}</span>
    </a>
  );
  const GoToMapButton = ({ zoneId, bookingDateStr }) => (

    <a
      href="#"
      onClick={() => GotoMapClick(zoneId, bookingDateStr)}
      className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
    >
      <img src={Images.GreenMap} alt="Map" className="img-fluid" />
      <span>{t("gotomap")}</span>
    </a>
  );

  const CancelBookingButton = ({ zoneId, bookingDateStr, meetingId }) => (
    <a
      href="#"
      className="main-btn cancel-btn gap-2"
      onClick={(e) => {
        e.preventDefault();
        if (!isLoading) {
          if (meetingId && meetingId > 0) {
            ShowHideModels(false);
            //setShowAlldayPostEventModal(false);
            setShowCancelConfirm(false);
            setShowCancelMeetingModal(true);
          }
          else {
            ShowHideModels(false);
            //setShowAlldayPostEventModal(false);
            setShowCancelMeetingModal(false)
            setShowCancelConfirm(true);
          }
        }
      }}
    >

      <span> {t("cancel_booking")}</span>
    </a>
  );

  const CancelBookingConfirmation = ({ event, zoneId }) => {

    const {
      bookingDate,
      spotId,
      bookingStartTime,
      bookingEndTime,
      spotName,
      guestUserFirstName,
      guestUserLastName,

    } = selectedEvent;
    const bookingDateStr = bookingDate;
    const displayBookingName = bookingType === 1
      ? [guestUserFirstName, guestUserLastName].filter(Boolean).join(" ").trim() || UserName
      : UserName;
    setCancelBookingSpotId(spotId);
    /* const titleText = formatReactString(t("react_cancel_booking_space_s"), [spotName], {
      defaultRenderer: () => (
        <span className="color-green">{spotName}</span>
      )
    }); */
    return (
      <div>
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          id="dateModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">

                <div className="close-modal">
                  <a onClick={(e) => {
                    e.preventDefault();
                    setShowCancelConfirm(false);

                  }}>
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>

                <div className="pt-4">
                  {/* <h5 className="popup-title">{titleText}</h5> */}
                  <h5 className="popup-title color-pblack">
                    {formatReactString(t("react_cancel_booking_space_s"), [spotName], {
                      defaultRenderer: () => (
                        <span className="color-green">{spotName}</span>
                      )
                    })}
                  </h5>
                </div>

                <div className="divider-line mt-3"></div>
                <div className="modal-details">
                  <div className="booking-name d-flex align-items-center gap-2">
                    <img src={Images.Participant} className="img-fluid" />
                    <h4>{displayBookingName}</h4>
                  </div>
                  <>
                    {/* No start/end time */}
                    <div className="booking-name d-flex align-items-center gap-2">
                      <img src={Images.GreenCalender} alt="repeat" className="img-fluid" />
                      <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                    </div>
                  </>
                </div >
                <div className="mb-4">
                  <button className="main-btn fill-green-btn  w-100" href="#"
                    onClick={async (e) => {
                      e.preventDefault();
                      if (!isLoading) {
                        setShowCancelConfirm(false);
                        await CancelBooking(
                          zoneId,
                          bookingDateStr,
                          cancelBookingSpotId
                        );
                      }
                    }}
                  > {t("confirm")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const CancelMeetingModal = ({ event, zoneId }) => {

    const {
      bookingDate,
      startDate,
      meetingId,
      meetingRepeat,
      repeatOption,
      repeatOptionDay,
      bookingStartTime,
      bookingEndTime,
      meetingName,

    } = selectedEvent;
    const bookingDateStr = bookingDate;

    const repeatIcon = useMemo(() => {
      if (!repeatOption) return null;          // "" or undefined → no icon
      if (repeatOption === "0") return Images.TimeIcon;

      return Images.RepeatEventClock;          // repeat clock icon
    }, [repeatOption]);

    if (!showCancelMeetingModal) return null;
    console.log("CancelMeetingModal- repeatOptionDay ", repeatOptionDay)
    return (
      <div>
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          id="dateModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">

                <div className="close-modal">
                  <a onClick={(e) => {
                    e.preventDefault();
                    setShowCancelMeetingModal(false);
                  }}>
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>
                <div className="pt-4">
                  <h5 className="popup-title color-pblack">
                    {formatReactString(t("react_cancel_meeting_s"), [meetingName], {
                      defaultRenderer: () => (
                        <span className="color-green">{meetingName}</span>
                      )
                    })}
                  </h5>
                </div>
                {/* <div className="pt-4">
                                      <h5 className="popup-title">{titleText}</h5>
                                  </div> */}

                <div className="divider-line mt-3"></div>
                <div className="modal-details">
                  <>
                    <div className="icon-with-list">
                      <div className="icon-wrap">
                        <img src={Images.Participant} className="img-fluid" />
                        <h4>{UserName}</h4>
                      </div>

                      <div className="icon-wrap">
                        <img src={Images.GreenCalender} alt="repeat" className="img-fluid" />
                        <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                      </div>

                      <div className="icon-wrap">
                        {repeatIcon && <img src={Images.RepeatEventClock} alt="repeat" className="img-fluid" />}
                        <h4>
                          {t("from")} <span> {bookingStartTime}</span> {t("to")} <span> {bookingEndTime}</span>
                        </h4>
                      </div>

                      <div className="icon-wrap">
                        <h4 className="ps-3 ms-2">
                          {repeatOption !== "No repeat" ? repeatOption : ""} {repeatOptionDay && repeatOptionDay !== 0 && repeatOptionDay !== "0" ? `(${repeatOptionDay})` : ""}

                        </h4>
                      </div>

                    </div>
                  </>
                </div >
                {meetingRepeat === 0 && (
                  <div className="mb-4">
                    <button
                      type="button"
                      className="main-btn fill-green-btn w-100"
                      disabled={isLoading}
                      onClick={() => {
                        CancelMeeting(meetingId, 1, startDate);
                      }}
                    >
                      {t("cancel")}
                    </button>
                  </div>
                )}

                {meetingRepeat > 0 && (
                  <div className="mb-4">
                    <button
                      type="button"
                      className="main-btn fill-green-btn w-100"
                      onClick={async () => {
                        if (!isLoading) {
                          setShowCancelMeetingModal(false);
                          setShowCancelMeetingDateSelectModal(true);
                        }
                      }}
                    >
                      {t("react_cancel_this_occurrence")}
                    </button>

                    <button
                      type="button"
                      className="main-btn fill-green-btn w-100 mt-2"
                      onClick={() => {
                        if (!isLoading) {
                          setShowCancelMeetingModal(false);
                          setTimeout(() => {
                            CancelMeeting(meetingId, 1, startDate);
                          }, 0);
                        }
                      }}
                    >
                      {t("react_cancel_the_series")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const CancelMeetingDateSelectModal = ({ event }) => {

    const [selectedCancelMeetingDate, setSelectedCancelMeetingDate] = useState(null);

    const {
      bookingDate,
      startDate,
      lastDateOfBookingAvailable,
      selectedDays,
      meetingId,
      meetingName,
    } = selectedEvent;
    const bookingDateStr = bookingDate;

    const cancelStartDate = startDate || bookingDateStr;

    /* -------------------- HOLIDAYS -------------------- */
    const holidaysArray = holidays || [];
    //console.log("CancelMeetingDateSelectModal- holidaysArray ", holidaysArray);
    const holidaysSet = useMemo(
      () => new Set(holidaysArray),
      [holidaysArray]
    );

    /* -------------------- SELECTED DAYS -------------------- */
    const selectedDaysArray = selectedDays || [];

    const selectedDaysSet = useMemo(
      () => new Set(selectedDaysArray),
      [selectedDaysArray]
    );

    const sortedSelectedDays = useMemo(() => {
      if (!selectedDaysArray.length) return [];
      return [...selectedDaysArray].sort(); // yyyy-mm-dd
    }, [selectedDaysArray]);

    const minSelectedDate = sortedSelectedDays[0];
    const maxSelectedDate =
      sortedSelectedDays[sortedSelectedDays.length - 1];
    //console.log("CancelMeetingDateSelectModal- minSelectedDate, maxSelectedDate ", minSelectedDate, maxSelectedDate);

    /* -------------------- DATE LOGIC -------------------- */
    function normalizeDate(date) {
      if (!date) return null;

      // If it's already a Date, use it; else convert from string
      const d = date instanceof Date ? date : new Date(date);

      // Check it's valid
      if (isNaN(d.getTime())) return null;

      return d.toISOString().slice(0, 10);
    }
    const isDateAllowedForPicker = (date) => {
      const dateStr = formatDateYYYYMMDD(date);

      // ❌ Holidays
      if (holidaysSet.has(dateStr)) return false;

      // ✅ Selected days logic
      if (selectedDaysSet.size > 0) {
        return selectedDaysSet.has(dateStr);
      }

      // ✅ Range logic
      if (lastDateOfBookingAvailable) {
        const start = normalizeDate(cancelStartDate);
        const end = normalizeDate(lastDateOfBookingAvailable);
        return dateStr >= start && dateStr <= end;
      }
      return true;
    };

    const toDateObject = (yyyyMMdd) => {
      if (!yyyyMMdd) return null;
      const [y, m, d] = yyyyMMdd.split("-").map(Number);
      return new Date(y, m - 1, d);
    };

    const minDate = lastDateOfBookingAvailable
      ? toDateObject(normalizeDate(cancelStartDate))
      : null;

    const maxDate = lastDateOfBookingAvailable
      ? toDateObject(normalizeDate(lastDateOfBookingAvailable))
      : null;

    /* -------------------- CALENDAR RANGE -------------------- */
    const calendarInitialDate =
      selectedDaysSet.size > 0 ? minSelectedDate : cancelStartDate;
    const addOneDay = (dateStr) => {
      const d = new Date(dateStr);
      d.setDate(d.getDate() + 1); // moves to next day
      return d.toISOString().slice(0, 10);
    };

    const calendarValidRange =
      selectedDaysSet.size > 0
        ? {
          start: minSelectedDate,
          end: addOneDay(maxSelectedDate),
        }
        : { start: cancelStartDate };

    //console.log("CancelMeetingDateSelectModal- calendarValidRange, ", calendarValidRange);
    if (!setShowCancelMeetingDateSelectModal) return null;
    //console.log("bookingDateStr,startDate, lastDateOfBookingAvailable, selectedDays, meetingId=", bookingDateStr, startDate, lastDateOfBookingAvailable, selectedDays, meetingId)
    return (
      <div>
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">

                {/* ❌ Close */}
                <div className="close-modal">


                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedCancelMeetingDate(null);
                      setShowCancelMeetingDateSelectModal(false);
                    }}
                  >
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>
                <div className="pt-4">
                  <h5 className="popup-title color-pblack">
                    {formatReactString(t("react_cancel_s"), [meetingName], {
                      defaultRenderer: () => (
                        <span className="color-green">{meetingName}</span>
                      )
                    })}
                  </h5>
                </div>
                <div className="divider-line mt-3 mb-3"></div>
                {/* 📅 CALENDAR */}
                <div className="hidden-datepicker-input my-3">
                  <DatePicker
                    locale={locale}
                    minDate={minSelectedDate}
                    maxDate={maxSelectedDate}
                    open={open}
                    inline
                    filterDate={isDateAllowedForPicker}
                    onChange={(date) => {
                      const selected = formatDateYYYYMMDD(date);
                      console.log("Allowed date clicked:", selected);

                      setSelectedCancelMeetingDate(selected);
                      setShowCancelMeetingDateSelectModal(false);
                      CancelMeeting(meetingId, 2, selected);
                    }}
                    dayClassName={(date) =>
                      isHolidayInList(date) ? "react-datepicker__day--holidayClass" : undefined
                    }
                  />

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const DeclineButton = ({ isLoading }) => (
    <div >
      <div>
        <a
          href="#"
          onClick={async (e) => {
            e.preventDefault();
            if (!isLoading) {
              ShowHideModels(false);
              setShowDeclineMeetingModal(true);
            }
          }}
          className="main-btn fill-red-btn w-100 mw-100">
          <img src={Images.Decline} className="img-fluid"></img>
          <span>{t("react_decline")}</span>
        </a>
      </div>
    </div>
  );

  const DeclineMeetingModal = ({ zoneId }) => {

    const {
      startDate,
      bookingDate,
      meetingId,
      meetingRepeat,
      repeatOption,
      repeatOptionDay,
      bookingStartTime,
      bookingEndTime,
      meetingName,

    } = selectedEvent;
    const bookingDateStr = bookingDate;

    console.log("startDate from DeclineMeetingModal - ", startDate);
    const repeatIcon = useMemo(() => {
      if (!repeatOption) return null;          // "" or undefined → no icon
      if (repeatOption === "0") return Images.TimeIcon;

      return Images.RepeatEventClock;          // repeat clock icon
    }, [repeatOption]);

    if (!showDeclineMeetingModal) return null;

    return (
      <div>
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          id="dateModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">

                <div className="close-modal">
                  <a onClick={(e) => {
                    e.preventDefault();
                    setShowDeclineMeetingModal(false);
                  }}>
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>

                <div className="pt-4">
                  <h5 className="popup-title color-pblack">
                    {formatReactString(t("react_decline_s"), [meetingName], {
                      defaultRenderer: () => (
                        <span className="color-green">{meetingName}</span>
                      )
                    })}
                  </h5>
                </div>

                <div className="divider-line mt-3"></div>
                <div className="modal-details">
                  <div className="icon-with-list">
                    <div className="icon-wrap">
                      <img src={Images.Participant} className="img-fluid" />
                      <h4>{UserName}</h4>
                    </div>
                    <>

                      <div className="icon-wrap">
                        <img src={Images.GreenCalender} alt="repeat" className="img-fluid" />
                        <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                      </div>

                      <div className="icon-wrap">
                        {repeatIcon && <img src={Images.RepeatEventClock} alt="repeat" className="img-fluid" />}
                        <h4>
                          {t("from")} <span>{bookingStartTime}</span> {t("to")} <span> {bookingEndTime}</span>
                        </h4>
                      </div>
                      <div className="icon-wrap">
                        <h4 className="ps-3 ms-3">
                          {repeatOption} {repeatOptionDay != "" && repeatOptionDay !== "0" ? `(${repeatOptionDay})` : ""}
                        </h4>
                      </div>

                    </>
                  </div >
                </div>
                {meetingRepeat === 0 && (
                  <div className="mb-4">
                    <button className="main-btn fill-green-btn  w-100" href="#"
                      onClick={async (e) => {
                        e.preventDefault();
                        if (!isLoading) {
                          DeclineMeeting(zoneId, bookingDateStr, meetingId, 1, startDate);
                        }
                      }}
                    > {t("react_decline")}</button></div>
                )}

                {meetingRepeat > 0 && (
                  <div className="mb-4">
                    <button
                      type="button"
                      className="main-btn fill-green-btn w-100"
                      onClick={async () => {
                        if (!isLoading) {
                          setShowDeclineMeetingModal(false);
                          setShowDeclineMeetingDateSelectModal(true);
                        }
                      }}
                    >
                      {t("react_decline_occurrence")}
                    </button>

                    <button
                      type="button"
                      className="main-btn fill-green-btn w-100 mt-2"
                      onClick={async () => {
                        if (!isLoading) {
                          setShowDeclineMeetingModal(false);
                          DeclineMeeting(zoneId, bookingDateStr, meetingId, 1, startDate);
                        }
                      }}
                    >
                      {t("react_decline_series")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const DeclineMeetingDateSelectModal = ({ event, zoneId }) => {
    const [selectedDeclineMeetingDate, setSelectedDeclineMeetingDate] = useState(null);

    const {
      bookingDate,
      startDate,
      lastDateOfBookingAvailable,
      selectedDays,
      meetingId,
      meetingName,
    } = selectedEvent;
    const bookingDateStr = bookingDate;

    const cancelStartDate = startDate || bookingDateStr;

    /* -------------------- HOLIDAYS -------------------- */
    const holidaysArray = holidays || [];
    //console.log("DeclineMeetingDateSelectModal- holidaysArray ", holidaysArray);
    const holidaysSet = useMemo(
      () => new Set(holidaysArray),
      [holidaysArray]
    );

    /* -------------------- SELECTED DAYS -------------------- */
    const selectedDaysArray = selectedDays || [];

    const selectedDaysSet = useMemo(
      () => new Set(selectedDaysArray),
      [selectedDaysArray]
    );

    const sortedSelectedDays = useMemo(() => {
      if (!selectedDaysArray.length) return [];
      return [...selectedDaysArray].sort(); // yyyy-mm-dd
    }, [selectedDaysArray]);

    const minSelectedDate = sortedSelectedDays[0];
    const maxSelectedDate =
      sortedSelectedDays[sortedSelectedDays.length - 1];
    //console.log("DeclineMeetingDateSelectModal- minSelectedDate, maxSelectedDate ", minSelectedDate, maxSelectedDate);

    /* -------------------- DATE LOGIC -------------------- */
    function normalizeDate(date) {
      if (!date) return null;

      // If it's already a Date, use it; else convert from string
      const d = date instanceof Date ? date : new Date(date);

      // Check it's valid
      if (isNaN(d.getTime())) return null;

      return d.toISOString().slice(0, 10);
    }

    const isDateAllowedForPicker = (date) => {
      const dateStr = formatDateYYYYMMDD(date);

      // ❌ Holidays
      if (holidaysSet.has(dateStr)) return false;

      // ✅ Selected days logic
      if (selectedDaysSet.size > 0) {
        return selectedDaysSet.has(dateStr);
      }

      // ✅ Range logic
      if (lastDateOfBookingAvailable) {
        const start = normalizeDate(cancelStartDate);
        const end = normalizeDate(lastDateOfBookingAvailable);
        return dateStr >= start && dateStr <= end;
      }

      return true;
    };

    /* -------------------- CALENDAR RANGE -------------------- */
    const calendarInitialDate =
      selectedDaysSet.size > 0 ? minSelectedDate : cancelStartDate;
    const addOneDay = (dateStr) => {
      const d = new Date(dateStr);
      d.setDate(d.getDate() + 1); // moves to next day
      return d.toISOString().slice(0, 10);
    };

    const calendarValidRange =
      selectedDaysSet.size > 0
        ? {
          start: minSelectedDate,
          end: addOneDay(maxSelectedDate),
        }
        : { start: cancelStartDate };

    //console.log("DeclineMeetingDateSelectModal- calendarValidRange, ", calendarValidRange);
    if (!setShowDeclineMeetingDateSelectModal) return null;
    //console.log("startDate, lastDateOfBookingAvailable, selectedDays, meetingId=", startDate, lastDateOfBookingAvailable, selectedDays, meetingId)
    return (
      <div>
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">

                {/* ❌ Close */}
                <div className="close-modal">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedDeclineMeetingDate(null);
                      setShowDeclineMeetingDateSelectModal(false);
                    }}
                  >
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>
                <div className="pt-4">
                  <h5 className="popup-title color-pblack">
                    {formatReactString(t("react_decline_s"), [meetingName], {
                      defaultRenderer: () => (
                        <span className="color-green">{meetingName}</span>
                      )
                    })}
                  </h5>
                </div>
                <div className="divider-line mt-3 mb-3"></div>
                {/* 📅 CALENDAR */}
                <div className="hidden-datepicker-input my-3">
                  <DatePicker
                    locale={locale}
                    minDate={minSelectedDate}
                    maxDate={maxSelectedDate}
                    open={open}
                    inline
                    filterDate={isDateAllowedForPicker}
                    onChange={(date) => {
                      const selected = formatDateYYYYMMDD(date);
                      console.log("Allowed date clicked:", selected);
                      setSelectedDeclineMeetingDate(selected);
                      console.log("Allowed date clicked:", selected);
                      setShowDeclineMeetingDateSelectModal(false);
                      DeclineMeeting(zoneId, bookingDateStr, meetingId, 2, selected);
                    }}
                    dayClassName={(date) =>
                      isHolidayInList(date) ? "react-datepicker__day--holidayClass" : undefined
                    }
                  />

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const SpotTakenButton = ({ zoneId, bookingDateStr }) => (
    <div >
      <div className="d-flex justify-content-between align-items-center ">
        <button className="main-btn fill-red-btn w-100" href="#"
          onClick={(e) => {
            e.preventDefault();
            if (!isLoading) {
              ShowHideModels(false);
              //setShowAlldayPostEventModal(false);
              setShowReportParkingViolationModal(true);
            }
          }}
        >
          <img src={Images.ExclamationCircle} alt="" className="img-fluid" />
          <span>{t("react_spot_taken")}</span>

        </button>
      </div>
    </div>
  );
  const ReportParkingViolationModal = ({ zoneId }) => {

    const [plateNo, setPlateNo] = useState("");
    const [plateError, setPlateError] = useState("");
    const {
      bookingDate,
      spotId,
      bookingPeriod,
      bookingStartTime,
      bookingEndTime,
      spotName,

    } = selectedEvent;
    const bookingDateStr = bookingDate;
    let titleText = `${t("react_is_someone_already_parked")}`;
    return (
      <>
        <div id="divReportParkingViolationModal">
          <div
            className="modal ctm-modalscroll-modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
              <div className="modal-content modal-radius">
                <div className="modal-body">
                  <div className="ctm-modal-header">
                    <div className="close-modal">
                      <a onClick={(e) => {
                        e.preventDefault();
                        setShowReportParkingViolationModal(false);
                      }}>
                        <img src={Images.Close} aria-label="Close" className="img-fluid" />
                      </a>
                    </div>

                    <div className="pt-4 text-center pe-4">
                      <h5 className="popup-title text-red pe-0">{titleText} <span>{spotName}?</span></h5>
                    </div>

                    <div className="divider-line mt-3"></div>
                  </div>
                  <div className="modal-des">
                    <div className="modal-scroll-inner">
                      <div className="text-center">
                        <p>{t("react_enter_license_plate_number")}</p>
                      </div>
                      <div>

                        <div className="form-row">
                          <label className="popup-inner-title m-0">{t("license_plate_offender")}</label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            value={plateNo}
                            onChange={(e) => {
                              setPlateNo(e.target.value);
                              setPlateError("");
                            }}
                            placeholder={t("vehicle_plate_placeholder")}
                          />
                          {plateError && (
                            <div className="error-text">
                              <img src={Images.ErrorMsg} alt="" />
                              <p>{plateError}</p>
                            </div>
                          )}
                        </div>
                        <div className="text-center"><p>{t("react_parking_violation_notification")}</p></div>
                      </div >
                    </div></div>
                  <div className="ctm-modal-footer">
                    <button className="main-btn fill-red-btn w-100" href="#"
                      onClick={async (e) => {
                        e.preventDefault();
                        if (!plateNo.trim()) {
                          setPlateError(t("react_vehicle_number_plate"));
                          return;
                        }

                        setShowReportParkingViolationModal(false);
                        if (!isLoading) {
                          await ParkingViolationReporting(zoneId, plateNo, spotId, spotName, bookingPeriod, bookingDateStr);
                        }
                      }}
                    >{t("react_send_to_parking_management")}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  const AlternateParkingSpotModal = ({ event, zoneId }) => {

    let titleText = `${t("react_parking_violation_reported")}`;
    let topContainerText = "";
    let bottomContainerText = "";
    let btnTxt = "";
    // True on exactly the screens whose primary button reads "Yes, take this space" -
    // i.e. an alternate space is actually being offered. Set beside btnTxt so the label
    // and the Cancel button below cannot drift apart.
    //
    // Screen 1 sets that label regardless of SpotId, so the old `SpotId > 0` gate hid
    // Cancel on a Screen 1 response carrying SpotId 0 - the reported bug.
    let isAlternateSpaceOffer = false;
    let availableSpotName = "";
    const {
      zoneName
    } = selectedEvent;
    console.log("parkingViolationReportingData--", parkingViolationReportingData);
    if (parkingViolationReportingData) {
      if (parkingViolationReportingData?.Screen === 1) {
        topContainerText = `${t("react_vehicle_parked_wrong_space")}`;
        bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingData?.Records?.ZoneName}:`;
        availableSpotName = parkingViolationReportingData?.Records?.SpotName;
        btnTxt = `${t("react_yes_take_this_space")}`;
        isAlternateSpaceOffer = true;
      }
      else if (parkingViolationReportingData?.Screen === 2) {
        topContainerText = `${t("react_parking_violation_reported")}`;
        bottomContainerText = `${t("no_parking_space_available")}`;
        btnTxt = t("confirm");

      }
      else if (parkingViolationReportingData?.Screen === 3) {
        if (parkingViolationReportingData?.Records?.SpotId === 0) {
          topContainerText = `${t("react_vehicle_not_registered")}`;
          bottomContainerText = `${t("no_parking_space_available")}`;
          btnTxt = t("confirm");

        }
        else if (parkingViolationReportingData?.Records?.SpotId > 0) {
          topContainerText = `${t("react_vehicle_not_registered")}`;
          bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingData?.Records?.ZoneName}:`;
          btnTxt = `${t("react_yes_take_this_space")}`;
          availableSpotName = parkingViolationReportingData?.Records?.SpotName;
          isAlternateSpaceOffer = true;
        }
      }
    }
    else return null;

    return (
      <>
        <div id="divAlternateParkingSpotModal">
          <div
            className="modal ctm-modalscroll-modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
              <div className="modal-content modal-radius">
                <div className="modal-body">
                  <div className="ctm-modal-header">
                    <div className="close-modal">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          setShowAlternateParkingSpotModal(false);
                        }}
                      >
                        <img src={Images.Close} aria-label="Close" className="img-fluid" />
                      </a>
                    </div>

                    <div className="pt-4 text-center">
                      <h5 className="popup-title pe-3 pb-0">{titleText}</h5>
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <img src={Images.Participant} className="img-fluid" />
                        <h4>{parkingViolationReportingData?.Records?.PlateNo}</h4>
                      </div>
                    </div>

                    <div className="pt-1 text-center">
                      <p>{topContainerText}</p>
                    </div>
                    <div className="divider-line mt-3"></div>
                  </div>
                  <div className="modal-des">
                    <div className="modal-scroll-inner">
                      <div className="text-center my-34">
                        <img src={Images.ParkingBooking} className="img-fluid" alt="Parking Booking" />
                      </div>

                      <div className="modal-details text-center">

                        <p>{bottomContainerText}
                          <h5 className="color-green d-block mt-2 mb-0">{availableSpotName ? availableSpotName : ""}</h5></p>

                      </div >
                    </div></div>
                  <div className="ctm-modal-footer">
                    <button className="main-btn fill-green-btn w-100" href="#"
                      onClick={async (e) => {
                        e.preventDefault();
                        if (!isLoading) {
                          setShowAlternateParkingSpotModal(false);
                          if (parkingViolationReportingData?.Records?.SpotId > 0) {
                            await AlternateParkingSpotBooking(zoneId);
                          }
                        }
                      }}
                    >{btnTxt}</button>
                    {/* Widened, never narrowed: anything that showed Cancel before still
                        does, and the offer screens that were missing it now get it. */}
                    {(isAlternateSpaceOffer || parkingViolationReportingData?.Records?.SpotId > 0) && (
                      <div className="d-block w-100">
                        <a
                          href="#"
                          className="main-btn cancel-btn gap-2"
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLoading) {
                              setShowAlternateParkingSpotModal(false);
                            }
                          }}
                        >
                          <span> {t("cancel")}</span>
                        </a>
                      </div>

                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  // RON-5375: opens NewMeetingModal in edit mode.
  // "Edit this event" (RescheduleType 2) is always available; "Edit all events in
  // this series" (RescheduleType 1) and "Edit this and all following events"
  // (RescheduleType 3) are shown only for recurring meetings (MeetingRepeat > 0).
  const EditMeetingButtons = ({ meetingRepeat }) => {
    const openEditMeeting = (rescheduleType) => {
      if (isLoading) return;
      setEditRescheduleType(rescheduleType);
      ShowHideModels(false);
      setShowEditMeetingModal(true);
    };

    return (
      <>
        <div className="">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              openEditMeeting(2);
            }}
            className="green-outline-with-icon w-100 mw-100 min-height-56"
          >
            <img src={Images.EditEventIcon} alt="" className="img-fluid" />
            <span>{t("react_edit_this_event")}</span>
          </a>
        </div>

        {meetingRepeat > 0 && (
          <>
            <div className="">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openEditMeeting(1);
                }}
                className="green-outline-with-icon w-100 mw-100 min-height-56"
              >
                <img src={Images.EditAllSeriesIcon} alt="" className="img-fluid" />
                <span>{t("react_edit_all_events_in_series")}</span>
              </a>
            </div>

            {/* d-none: hidden for the time being until the API supports RescheduleType 3 */}
            <div className="d-none">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  openEditMeeting(3);
                }}
                className="green-outline-with-icon w-100 mw-100 min-height-56"
              >
                <img src={Images.EditFollowingEventsIcon} alt="" className="img-fluid" />
                <span>{t("react_edit_this_and_following_events")}</span>
              </a>
            </div>
          </>
        )}
      </>
    );
  };

  const ReScheduleMeetingButton = ({ zoneId, bookingDateStr }) => (
    <div className="">
      <a href="#"
        onClick={(e) => {
          e.preventDefault();
          if (!isLoading) {
            ShowHideModels(false);
            setShowRescheduleMeetingModal(true);
          }
        }}
        className="green-outline-with-icon w-100 mw-100 min-height-56"            >
        {/* <img src={Images.reschedule} alt="Edit" className="img-fluid" /> */}
        <span>{t("react_reschedule")}</span>
      </a>
    </div>
  );
  const ReScheduleMeetingModal = ({
    selectedZoneId,
    selectedRescheduleDate,
    setSelectedRescheduleDate,
    setShowReScheduleMeetingDateSelectModal
  }) => {
    const {

      zoneName,
      bookingDate,
      meetingRepeat,
      isApproversExist,
      showApproverDate,
      meetingId,
      meetingName,
      timeIntervals = []   // ✅ important default
    } = selectedEvent;
    const bookingDateStr = bookingDate;
    const [showDateInput, setShowDateInput] = useState(false);
    useEffect(() => {
      if (rescheduledBookingOccurrence === 1) {
        setShowDateInput(false);
      } else if (rescheduledBookingOccurrence === 2) {
        setShowDateInput(true);
      }
    }, [rescheduledBookingOccurrence]);
    useEffect(() => {
      if (!selectedRescheduleDate && bookingDate) {
        setSelectedRescheduleDate(bookingDate);
      }
    }, [bookingDate]);

    const [selectedFrom, setSelectedFrom] = useState("");
    const [selectedTo, setSelectedTo] = useState("");

    const [showSlots, setShowSlots] = useState(false);
    const [activePicker, setActivePicker] = useState(null);
    const [timeError, setTimeError] = useState("");

    const resetRescheduleMeetingModal = () => {
      setTimeError("");
      setSelectedFrom("");
      setSelectedTo("");
      setShowSlots(false);
      setActivePicker(null);
      setRescheduledBookingOccurrence(1);
      setShowDateInput(false);
      setSelectedRescheduleDate("");
    };


    const handleSlotClick = (time) => {
      setTimeError("");
      //console.log("handleSlotClick time-", time, activePicker);
      if (activePicker === "FROM") {
        setSelectedFrom(time);

        // reset end if invalid
        if (timeIntervals.indexOf(selectedTo) <= timeIntervals.indexOf(time)) {
          setSelectedTo("00:00");
        }
        setShowSlots(false);
        setActivePicker(null);
        return;
      }

      if (activePicker === "TO") {
        if (timeIntervals.indexOf(time) <= timeIntervals.indexOf(selectedFrom)) {
          setTimeError(t("react_end_time_gt_start"));
          return;
        }
        setSelectedTo(time);
        setShowSlots(false);
        setActivePicker(null);
      }
    };

    // 🔹 Handlers
    const openFromPicker = () => {
      setActivePicker("FROM");
      setShowSlots(true);
      setTimeError("");
    };

    const openToPicker = () => {
      if (!selectedFrom) {
        setTimeError(t("select") + " " + t("start_time"));
        return;
      }
      setActivePicker("TO");
      setShowSlots(true);
      setTimeError("");
    };

    // 1️⃣ Dropdown visibility
    const showDropdown = meetingRepeat !== 0;

    // 2️⃣ Option visibility
    let showAlloccurrence = false;
    let showSelectDate = false;

    /* if (isApproversExist === 1 && showApproverDate === 1) {
      showSelectDate = false;
    } */
    console.log("isApproversExist, showApproverDate ", isApproversExist, showApproverDate);
    if (isApproversExist === 1) {
      showAlloccurrence = true;

      if (showApproverDate == 0) {
        showSelectDate = true;
      }
    }
    else {
      showAlloccurrence = true;
      showSelectDate = true;
    }


    // 3️⃣ Build options dynamically
    const rescheduledBookingOccurrenceOptions = [];

    if (showAlloccurrence) {
      rescheduledBookingOccurrenceOptions.push({
        id: 1,
        name: `${t("react_all_occurrences")}`
      });
    }

    if (showSelectDate) {
      rescheduledBookingOccurrenceOptions.push({
        id: 2,
        name: `${t("select")} ${t("date")}`
      });
    }

    let titleText = `${t("react_when_reschedule")}`;

    const repeatIcon = useMemo(() => {
      if (!repeatOption) return null;          // "" or undefined → no icon
      if (repeatOption === "0") return Images.TimeIcon;

      return Images.RepeatEventClock;          // repeat clock icon
    }, [repeatOption]);

    if (!showRescheduleMeetingModal) return null;

    return (
      <div>
        <div
          className="modal ctm-modalscroll-modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          id="dateModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">
                <div className="ctm-modal-header">
                  <div className="close-modal">
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        resetRescheduleMeetingModal();
                        setShowRescheduleMeetingModal(false);
                      }}
                    >
                      <img src={Images.Close} aria-label="Close" className="img-fluid" />
                    </a>
                  </div>

                  <div className="pt-4">
                    <h5 className="popup-title">{titleText}</h5>
                  </div>

                  <div className="divider-line mt-3"></div>
                </div>
                <div className="modal-des">
                  <div className="modal-scroll-inner">
                    <div className="icon-wrap mb-3">
                      <img src={Images.ZoneMap} className="img-fluid" alt="spot" />
                      <span className="zone_text"> {zoneName}</span>
                    </div>

                    {showDropdown && (
                      <div className="form-row">
                        <label className="popup-inner-title m-0">{t("react_type_label")}</label>
                        <CustomSearchableDropdown
                          items={rescheduledBookingOccurrenceOptions}
                          value={rescheduledBookingOccurrence}
                          labelKey="name"
                          valueKey="id"
                          searchable={false}
                          onChange={(value) => {
                            const reoccurrenceValue = Number(value);
                            setRescheduledBookingOccurrence(reoccurrenceValue);

                            if (reoccurrenceValue === 1) {
                              setSelectedRescheduleDate("");
                              setShowDateInput(false);
                            } else if (reoccurrenceValue === 2) {
                              setShowDateInput(true);
                            }
                          }}
                        />
                      </div>
                    )}

                    {showDateInput && (
                      <div className="form-row mt-2">
                        <input
                          type="text"
                          className="form-control"
                          autoComplete="off"
                          readOnly
                          value={formatDateToEEEddMMM(selectedRescheduleDate)}
                          placeholder={t("please_select_date")}
                          onClick={() => {
                            setShowRescheduleMeetingModal(false);
                            setShowReScheduleMeetingDateSelectModal(true);
                          }}
                        />
                      </div>
                    )}

                    <div className="custom-timepicker">
                      <h6 className="popup-inner-title">{t("react_select_time")}</h6>
                      <div
                        className={`time-selection ${selectedFrom && selectedTo && !(selectedFrom === "00:00" && selectedTo === "00:00")
                          ? "ctm-success"
                          : ""
                          }`}
                        id="selectedBox"
                      >
                        <div className="row">
                          <div className="col-md-6 rightArrow">
                            <div className="time-alignment pl20">
                              <label onClick={openFromPicker}>{t("from")}</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedFrom === "00:00" ? "" : (selectedFrom || "")}
                                placeholder="00:00"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={openFromPicker}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="time-alignment pl40">
                              <label onClick={openToPicker}>{t("to")}</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedTo === "00:00" ? "" : (selectedTo || "")}
                                placeholder="00:00"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={openToPicker}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {timeError && (
                        <div className="error-text"><img src={Images.ErrorMsg} className="img-fluid"></img> <p>{timeError}</p></div>
                      )}

                      {showSlots && (
                        <div className="slot-container d-grid mb-3">
                          {timeIntervals.map((time, idx) => {
                            const isSelected = time === selectedFrom || time === selectedTo;

                            return (
                              <div
                                key={idx}
                                className={`slot ${isSelected ? "active" : ""}`}
                                onClick={() => handleSlotClick(time)}
                              >
                                {time}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="ctm-modal-footer">
                  <button
                    className="main-btn fill-green-btn w-100 mb-3"
                    href="#"
                    onClick={async (e) => {
                      e.preventDefault();
                      if (isLoading) return;

                      if (!selectedFrom) {
                        setTimeError(t("select") + " " + t("start_time"));
                        return;
                      }

                      if (!selectedTo || selectedTo === "00:00") {
                        setTimeError(t("select") + " " + t("end_time"));
                        return;
                      }

                      if (timeIntervals.indexOf(selectedTo) <= timeIntervals.indexOf(selectedFrom)) {
                        setTimeError(t("react_end_time_must_be_greater_than_start_time"));
                        return;
                      }

                      if (timeIntervals.indexOf(selectedFrom) < timeIntervals.indexOf(selectedTo)) {
                        setShowRescheduleMeetingModal(false)
                        RescheduleMeeting(
                          selectedZoneId,
                          selectedFrom,
                          selectedTo,
                          rescheduledBookingOccurrence,
                          bookingDateStr,
                          meetingId,
                          selectedRescheduleDate
                        );
                      }
                    }}
                  >
                    {t("confirm")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const ReScheduleMeetingDateSelectModal = ({ zoneId, event, onDateSelect }) => {
    const [selectedReScheduleMeetingDate, setSelectedReScheduleMeetingDate] = useState(null);
    const {
      bookingDate,
      startDate,
      lastDateOfBookingAvailable,
      selectedDays,
      meetingId,
      meetingName,
    } = selectedEvent;
    const bookingDateStr = bookingDate;

    const cancelStartDate = startDate || bookingDateStr;

    /* -------------------- HOLIDAYS -------------------- */
    const holidaysArray = holidays || [];
    //console.log("ReScheduleMeetingDateSelectModal- holidaysArray ", holidaysArray);
    const holidaysSet = useMemo(
      () => new Set(holidaysArray),
      [holidaysArray]
    );

    /* -------------------- SELECTED DAYS -------------------- */
    const selectedDaysArray = selectedDays || [];

    const selectedDaysSet = useMemo(
      () => new Set(selectedDaysArray),
      [selectedDaysArray]
    );

    const sortedSelectedDays = useMemo(() => {
      if (!selectedDaysArray.length) return [];
      return [...selectedDaysArray].sort(); // yyyy-mm-dd
    }, [selectedDaysArray]);

    const minSelectedDate = sortedSelectedDays[0];
    const maxSelectedDate =
      sortedSelectedDays[sortedSelectedDays.length - 1];
    //console.log("ReScheduleMeetingDateSelectModal- minSelectedDate, maxSelectedDate ", minSelectedDate, maxSelectedDate);

    /* -------------------- DATE LOGIC -------------------- */
    function normalizeDate(date) {
      if (!date) return null;

      // If it's already a Date, use it; else convert from string
      const d = date instanceof Date ? date : new Date(date);

      // Check it's valid
      if (isNaN(d.getTime())) return null;

      return d.toISOString().slice(0, 10);
    }


    const isDateAllowedForPicker = (date) => {
      const dateStr = formatDateYYYYMMDD(date);
      // ❌ Holidays
      if (holidaysSet.has(dateStr)) return false;

      // ✅ Selected days logic
      if (selectedDaysSet.size > 0) {
        return selectedDaysSet.has(dateStr);
      }

      // ✅ Range logic
      if (lastDateOfBookingAvailable) {
        const start = normalizeDate(cancelStartDate);
        const end = normalizeDate(lastDateOfBookingAvailable);
        return dateStr >= start && dateStr <= end;
      }

      return true;
    };

    /* -------------------- CALENDAR RANGE -------------------- */
    const calendarInitialDate =
      selectedDaysSet.size > 0 ? minSelectedDate : cancelStartDate;
    const addOneDay = (dateStr) => {
      const d = new Date(dateStr);
      d.setDate(d.getDate() + 1); // moves to next day
      return d.toISOString().slice(0, 10);
    };
    const calendarValidRange =
      selectedDaysSet.size > 0
        ? {
          start: minSelectedDate,
          end: addOneDay(maxSelectedDate),
        }
        : { start: cancelStartDate };

    console.log("ReScheduleMeetingDateSelectModal- calendarValidRange, ", calendarValidRange);
    if (!setShowReScheduleMeetingDateSelectModal) return null;
    //console.log("bookingDateStr,startDate, lastDateOfBookingAvailable, selectedDays, meetingId=", bookingDateStr, startDate, lastDateOfBookingAvailable, selectedDays, meetingId)
    return (
      <div>
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-custom-width">
            <div className="modal-content modal-radius">
              <div className="modal-body">

                {/* ❌ Close */}
                <div className="close-modal">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedReScheduleMeetingDate(null);
                      setShowReScheduleMeetingDateSelectModal(false);
                      setShowRescheduleMeetingModal(false);
                      setRescheduledBookingOccurrence(1);
                      setSelectedRescheduleDate("");
                    }}
                  >
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>

                </div>
                <div className="pt-4">
                  <h5 className="popup-title color-pblack">
                    {formatReactString(t("react_reschedule_s"), [meetingName], {
                      defaultRenderer: (val, type, index) => (
                        <span key={`reschedule-title-${index}`} className="color-green">{val}</span>
                      )
                    })}
                  </h5>
                </div>
                <div className="divider-line mt-3 mb-3"></div>
                {/* 📅 CALENDAR */}
                <div className="hidden-datepicker-input">
                  <DatePicker
                    locale={locale}
                    minDate={minSelectedDate}
                    maxDate={maxSelectedDate}
                    open={open}
                    inline
                    filterDate={isDateAllowedForPicker}
                    onChange={(date) => {
                      const selected = formatDateYYYYMMDD(date);
                      console.log("Allowed date clicked:", selected);
                      if (!isDateAllowedForPicker(selected)) return;
                      onDateSelect(selected);
                      setShowReScheduleMeetingDateSelectModal(false);
                    }}
                  />

                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  function GotoMapClick(zoneId, bookingDateStr) {
    if (mapAvailableType === 2 || mapAvailableType === 3) {

      history.push("/map", {
        selectedZoneId: zoneId,
        selectedDate: bookingDateStr
      });

    } else {
      history.push("/no-map-available", { zoneId });
    }

  }

  async function CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId) {
    console.log(
      `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId},bookingType=${bookingType}`
    );
    try {
      if (isLoading) return;
      setIsLoading(true);
      const reqParams = {
        BookingDate: bookingDateStr,
        SpotId: cancelBookingSpotId,
        ZoneId: zoneId,
        IsGuest: bookingType === 1 ? 1 : 0,
      };

      const response = await CancelBooking_api(reqParams);
      console.log("CancelBooking_api response:", response);
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });
      if (response && response.Data?.ResponseCode === 200) {
        setShowCancelConfirm(false);
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling CancelBooking_api:", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function CancelMeeting(meetingId, CancelSelect, CancelDate) {
    /* console.log(
        `Cancel Meeting Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, MeetingId=${meetingId}, CancelSelect=${CancelSelect} , CancelDate=${CancelDate}`
    ); */
    if (isLoading) return;
    setIsLoading(true);
    try {
      const reqParams = {
        BookingId: meetingId,
        CancelDate: CancelDate,
        CancelSelect: CancelSelect,
      };

      const response = await CancelMeeting_api(reqParams);
      console.log("CancelMeeting_api response:", response);

      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });
      if (response && response.Data?.ResponseCode === 200) {
        setShowCancelMeetingDateSelectModal(false);
        setShowCancelMeetingModal(false);
        ShowHideModels(false);
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        console.error("Cancel meeting failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling CancelMeeting_api:", error);
    } finally {
      setIsLoading(false);
    }
  }
  async function DeclineMeeting(zoneId, bookingDateStr, meetingId, DeclineSelect, DeclineDate) {
    console.log(
      `Decline Meeting Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, MeetingId=${meetingId}`
    );
    if (isLoading) return;
    setIsLoading(true);
    try {
      const reqParams = {
        BookingId: meetingId,
        DeclineDate: DeclineDate,
        DeclineSelect: DeclineSelect,
      };

      const response = await DeclineMeeting_api(reqParams);
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });
      console.log("DeclineMeeting_api response:", response);
      if (response && response.Data?.ResponseCode === 200) {
        setShowDeclineMeetingDateSelectModal(false);
        setShowDeclineMeetingModal(false);
        ShowHideModels(false);
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        setNotification({
          type: "error",
          title: "Error",
          message: response?.Data?.ErrorMessage || t("something_went_wrong")
        });
        console.error("Decline meeting failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling DeclineMeeting_api:", error);
    } finally {
      setIsLoading(false);
    }
  }
  async function ParkingViolationReporting(zoneId, plateNoStr, spotIdStr, spotNameStr, bookingPeriodStr, bookingDateStr) {
    console.log(
      `ParkingViolationReporting Clicked: ZoneId=${zoneId}, SpotId=${spotIdStr}, SpotName=${spotNameStr}`
    );

    try {
      if (isLoading) return;
      setIsLoading(true);
      const spotViolationTypeStr = bookingPeriodStr === 2 ? 1 : 0;
      // RON-1840: the API rejects numeric ids here - Postman only succeeds with
      // strings, and a numeric payload comes back as a 500 with no CORS headers,
      // which the browser surfaces as a bare network failure. `?? ""` keeps a
      // missing id as "" rather than the string "undefined".
      const reqParams = {
        ZoneId: String(zoneId ?? ""),
        PlateNo: plateNoStr,
        SpotViolationType: String(spotViolationTypeStr),
        SpotId: String(spotIdStr ?? ""),
        SpotName: spotNameStr,
        Tags: "",
      };

      const response = await ReportParkingViolation_api(reqParams);
      console.log("ReportParkingViolation_api response:", response);

      if (response && response.Data?.ResponseCode === 200) {
        console.log("Parking violation reported successfully.", response.Data);
        setParkingViolationReportingData(response.Data);
        console.log("ParkingViolationReportingData-->", parkingViolationReportingData);
        //resetValues();
        setShowReportParkingViolationModal(false);
        setShowAlternateParkingSpotModal(true);
      } else {
        setNotification({
          type: "error",
          title: "Error",
          message: response?.Data?.ErrorMessage || t("something_went_wrong")
        });
        console.error("ReportParkingViolation_api failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling ReportParkingViolation_api:", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function AlternateParkingSpotBooking(zoneId, bookingDateStr) {
    if (!parkingViolationReportingData) return;

    try {

      setIsLoading(true);
      // Alternate zone returned by ReportParkingViolation_api (RON-5587)
      const alternateZoneId = parkingViolationReportingData?.Records?.AlternateZoneId;
      const reqParams = {
        ViolatedSpotId: parkingViolationReportingData?.Records?.ViolatedSpotId,
        SpotId: parkingViolationReportingData?.Records?.SpotId,
        ZoneId: zoneId,
        AlternateZoneId: alternateZoneId,
        Tags: "0",
        BookingId: parkingViolationReportingData?.Records?.BookingId,
        StartTime: parkingViolationReportingData?.Records?.StartTime,
        EndTime: parkingViolationReportingData?.Records?.EndTime,
        NewBookingPeriod: parkingViolationReportingData?.Records?.NewBookingPeriod,
      };

      const response = await GetAlternateParkingSpot_api(reqParams);
      console.log("GetAlternateParkingSpot_api response:", response);
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });
      if (response && response.Data?.ResponseCode === 200) {
        setShowAlternateParkingSpotModal(false);
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        console.error("AlternateParkingSpotBooking failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling GetAlternateParkingSpot_api:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const checkIncheckOut = async (CheckInFlag, zoneId, CheckInDate, spotId) => {
    try {

      setIsLoading(true);

      const reqParams = {
        CheckInFlag: CheckInFlag,
        ZoneId: zoneId,
        CheckInDate: CheckInDate,
        SpotId: spotId,
      };

      console.log("checkIncheckOut() - ReqParams:", reqParams);
      const response = await CheckInUser_api(reqParams);
      console.log("CheckInUser_api() - response -- ", response);
      handleApiUiResponse(response, {
        successToaster: 0,
        errorToaster: 0,
        alertPopup: 1,
        onConfirmByCode: {
          449: async () => {
            if (!zoneId) return;
            await refreshList();
          }
        }
      });
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      /* handleApiUiResponse(response, {
                successToaster: 1,
                errorToaster: 1,
                alertPopup: 1
            }); */
      if (response?.Data?.ResponseCode === 200) {
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        /*  setNotification({
           type: "error",
           title: "Error",
           message: response?.Data?.ErrorMessage || "Something went wrong."
         }); */
        console.error("CheckInUser_api() failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling checkIncheckOut:", error);
    } finally {
      ShowHideModels(false);
      //setShowAlldayPostEventModal(false);
      //resetValues();
      setIsLoading(false);
    }
  };

  async function RescheduleMeeting(zoneId, startTime, endTime, rescheduledBookingOccurrence, bookingDateStr, meetingId, RescheduledDate) {
    console.log(
      `Reschedule Meeting Clicked: zoneId=${zoneId}, startTime=${startTime}, endTime=${endTime}, rescheduledBookingOccurrence=${rescheduledBookingOccurrence},
            bookingDateStr=${bookingDateStr}, meetingId=${meetingId}, RescheduledDate=${formatDate(RescheduledDate)}`
    );
    try {
      if (isLoading) return;
      setIsLoading(true);
      const reqParams = {
        BookingId: meetingId,
        StartTime: startTime,
        EndTime: endTime,
        RescheduledDate: formatDate(RescheduledDate),
        RescheduledBookingOccurrence: rescheduledBookingOccurrence,
      };

      const response = await RescheduleMeeting_api(reqParams);
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });
      console.log("RescheduleMeeting_api response:", response);
      setShowRescheduleMeetingModal(false);
      //const result = handleResponseCode(response);
      if (response && response.Data?.ResponseCode === 200) {
        await delay(1500);
        setSelectedRescheduleDate("");
        setRescheduledBookingOccurrence(0);
        resetValues();
        await refreshList();
        setIsLoading(false);
      } else {

        console.error("Reschedule meeting failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling RescheduleMeeting_api:", error);

    } finally {
      setIsLoading(false);
    }
  }
  const resetValues = () => {
    setBookingData([]);
    setTotalBookings(0);
    setPage(1);
    setSpotTagList([]);
    setRepeatOption("0");
    setClickedFullDay(null);

    setParkingViolationReportingData(null);
    setShowPostEventModal(false);
    setShowMyInvitationEventModal(false);

    setShowCancelConfirm(false);
    setShowReportParkingViolationModal(false);
    setShowAlternateParkingSpotModal(false);

    setIsLoading(false);
    setIsInitialLoading(false);

    // My Invitations belongs- start
    setShowMyInvitationEventModal(false);
    setShowReportParkingViolationModalForInv(false);
    setShowAlternateParkingSpotModalForInv(false);
    setParkingViolationReportingDataForInv(null);
    // My Invitations belongs- end
  };
  // My Bookings UI Component - End here...

  const ShowHideModels = (showStatus) => {
    let revStatus = showStatus === true ? false : false;
    console.log("ShowHideModels--showStatus, revStatus, bookingType=", showStatus, revStatus, bookingType)
    if (bookingType === 0) {
      setShowPostEventModal(showStatus);
      setShowMyInvitationEventModal(revStatus)
    }
    else if (bookingType === 1) {
      setShowMyInvitationEventModal(showStatus);
      setShowPostEventModal(revStatus);
    }
  }

  const refreshList = async () => {
    setPage(1);
    setBookingData([]);
    setHasMore(true);
    setTotalPages(1);

    await fetchData(1);
  };
  // My Invitation UI Component - Start here...
  const MyInvitationEventModal = ({ onClose }) => {

    const {
      // -------- Basic Info --------
      zoneId,
      zoneName,
      zoneType,
      zoneCurrentDateTime,

      spotId,
      spotName,
      spotType,
      spotTagList = [],

      // -------- User Info --------
      guestUserId,
      guestUserFirstName,
      guestUserLastName,

      // -------- Booking Date/Time --------
      bookingDate,
      bookingStartTime,
      bookingEndTime,
      isHourlyBooking,
      bookingPeriod,

      // -------- Map --------
      mapExist,
      mapType,

      // -------- Check-In --------
      checkInFlag,
      checkInType = [],
      checkInLevelType,

      // -------- Extra --------
      showReportLabel,

    } = selectedEvent || {};

    const bookingDateStr = bookingDate;
    console.log("selectedEvent---", selectedEvent, spotId)
    const { displayMonth, displayYear } =
      useBookingDisplayDate(bookingDateStr, setSelectedDay);

    useEffect(() => {
      setMapAvailable(mapExist);
      setMapAvailableType(mapType);
      setSelectedZoneId(zoneId);
      setClickedFullDay(bookingDate);
      setSpotTagList(spotTagList);
    }, [mapExist, mapType, zoneId, bookingDate]);

    const isCheckIn = (checkInType.length > 0 && (checkInType.includes(2)) && spotId >= 0 && (checkInFlag === 0 || checkInFlag === 2));
    //console.log("isCheckIn--->isCheckIn, checkInType, spotId, checkInFlag, guestUserId=", isCheckIn, checkInType, spotId, checkInFlag, guestUserId);
    const showCheckOut = checkInType.includes(0) ? false : true;

    let showSpaceTakenButton = false;

    const today = new Date().toISOString().split("T")[0];

    if (
      zoneType === 1 &&
      spotId > 0 &&
      showReportLabel === 1 &&
      bookingDate === today
    ) {
      showSpaceTakenButton = true;
    }

    let showCancelButton = true;

    //let titleText = t("YourBookingForSpace") + " " + spotName;
    let titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
      defaultRenderer: (val) => (
        <span className="color-dark-black">{spotName}</span>
      )
    });

    const repeatIcon = useMemo(() => {
      if (!repeatOption) return null;          // "" or undefined → no icon
      if (repeatOption === "0") return Images.TimeIcon;

      return Images.RepeatEventClock;          // repeat clock icon
    }, [repeatOption]);

    /* -------------------- ACTION BUTTONS -------------------- */

    // Shared by renderActionButtons and the button count, so the two cannot drift.
    const showCheckOutButton =
      !isCheckIn && showCheckOut && spotId >= 0 &&
      Array.isArray(checkInType) && checkInType.length > 0 && checkInType.includes(2) && checkInFlag === 1;
    const showGoToMapButton = mapExist === 1 && mapType !== 1;

    const actionButtonCount =
      [isCheckIn, showCheckOutButton, showSpaceTakenButton, showGoToMapButton, showCancelButton === true]
        .filter(Boolean).length;

    const renderActionButtons = () => {

      //if (!bookingForModal) return null;
      console.log("My Invitation Event Modal Testing")
      return (
        <>
          {/* Check In Button -- Allow Only Manual*/}
          {/* Only for Today's Booking - After booking conditions */}
          {isCheckIn && (
            <CheckInButtonForInvitation zoneId={zoneId} checkInFlag={1} CheckInDate={getCurrentDateTime()} spotId={spotId} guestUserId={guestUserId} />
          )}
          {/* Check Out Button -- Allow Only Manual*/}
          {showCheckOutButton && (
            <CheckOutButtonForInvitation zoneId={zoneId} checkInFlag={2} CheckInDate={getCurrentDateTime()} spotId={spotId} guestUserId={guestUserId} />
          )}
          {/* Space taken button-- Allow Only For Today's Booking */}
          {showSpaceTakenButton && (
            <SpotTakenButtonForInvitation zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} />
          )}
          {/* GoTo Map Button */}
          {showGoToMapButton && (
            <GoToMapButton zoneId={zoneId} bookingDateStr={bookingDateStr} />
          )}
          {/*Cancel Booking Button */}    {/*SHOW Cancel Booking when condition is FALSE */}
          {showCancelButton === true && (
            <CancelBookingButton zoneId={zoneId} bookingDateStr={bookingDateStr} meetingId={0} />
          )}

        </>
      );
    }

    /* -------------------- JSX -------------------- */

    return (
      <div
        className={`modal ctm-modalscroll-modal${actionButtonCount > 3 ? " ctm-space-modal" : ""}`}
        style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
        id="dateModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered modal-custom-width">
          <div className="modal-content modal-radius">
            <div className="modal-body">
              <div className="ctm-modal-header">
                <div className="close-modal">
                  <a onClick={onClose}>
                    <img src={Images.Close} aria-label="Close" className="img-fluid" />
                  </a>
                </div>

                <div className="pt-4">
                  <h5 className="popup-title pb-0">{titleText}</h5>
                </div>

                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                  <div className="selected-current-date">
                    <span>{selectedDay}</span>
                    <span>{t(displayMonth)} {displayYear}</span>

                  </div>
                </div>

                <div className="divider-line mt-3"></div>
              </div>
              <div className="modal-des">
                <div className="modal-scroll-inner">
                  <div className="icon-with-list">
                    {bookingDate !== "" && (
                      <>
                        {isHourlyBooking ? (
                          <>
                            {/* Start & End time exist */}
                            {bookingStartTime !== "" && bookingEndTime !== "" && (
                              <div className="icon-wrap">
                                {repeatIcon && <img src={repeatIcon} alt="repeat" className="img-fluid" />}
                                <h4>
                                  {bookingStartTime} - {bookingEndTime},{" "}
                                  {formatDateToEEEddMMM(bookingDate)}
                                </h4>
                              </div>
                            )}
                          </>
                        ) : (
                          /* Not hourly → All day */
                          <div className="icon-wrap">
                            {repeatIcon && <img src={repeatIcon} alt="repeat" className="img-fluid" />}
                            <h4 className="ps-1 ms-1">
                              {t("all_day")} <span>{formatDateToEEEddMMM(bookingDate)}</span>
                            </h4>
                          </div>
                        )}
                      </>
                    )}

                    <div className="icon-wrap">
                      <img src={Images.Participant} alt="user" className="img-fluid" />
                      <h4 className="ps-1 ms-1">{guestUserFirstName} {guestUserLastName}</h4>
                    </div>

                    {/* {spotTagList && (
                    <div>
                      <SpotTags spotTagList={spotTagList} />
                    </div>
                  )} */}
                  </div>
                </div>
              </div>
              <div className="ctm-modal-footer">
                {renderActionButtons()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


  const CheckInButtonForInvitation = ({ checkInFlag, zoneId, CheckInDate, spotId, guestUserId }) => (
    <div className="d-flex justify-content-between align-items-center gap-3 ">
      <div className="d-block w-100">
        <a
          href="#"
          onClick={(e) => {
            if (isLoading) return;
            e.preventDefault();
            if (!isLoading) {
              ShowHideModels(false);
              checkIncheckOutForInvitation(checkInFlag, zoneId, CheckInDate, spotId, guestUserId)
            }
          }}
          className="fc-checkInBtn-button w-100 fc-checkInBtn-img">
          <img src={Images.CheckInIcon} className="img-fluid"></img>
          <span>{t("react_check_in")}</span>
        </a>
      </div>
    </div>
  );
  const CheckOutButtonForInvitation = ({ checkInFlag, zoneId, CheckInDate, spotId, guestUserId }) => (
    <div >
      <div className="d-block w-100 ">
        <a
          href="#"
          onClick={(e) => {
            if (isLoading) return;
            e.preventDefault();
            if (!isLoading) {
              ShowHideModels(false);
              checkIncheckOutForInvitation(checkInFlag, zoneId, CheckInDate, spotId, guestUserId);
            }
          }}
          className="fc-checkInBtn-button fc-button fc-button-primary active w-100 fc-checkInBtn-img"
        >
          <img src={Images.CheckInIcon} className="img-fluid"></img>
          <span>{t("react_check_out")}</span>
        </a>
      </div>
    </div>
  );

  const checkIncheckOutForInvitation = async (CheckInFlag, zoneId, CheckInDate, spotId, guestUserId) => {
    try {
      console.log("checkIncheckOutForInvitation() called with:", { CheckInFlag, zoneId, CheckInDate, spotId, guestUserId });
      setIsLoading(true);

      const reqParams = {
        CheckInFlag: CheckInFlag,
        ZoneId: zoneId,
        CheckInDate: CheckInDate,
        SpotId: spotId,
        GuestUserId: guestUserId,
        //ScanTime: checkInLevelType === 4 ? 1 : 0,
      };

      console.log("checkIncheckOutForInvitation() - ReqParams:", reqParams);
      const response = await CheckInForGuestUser_api(reqParams);
      console.log("CheckInForGuestUser_api() - response -- ", response);
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 0,
        errorToaster: 0,
        alertPopup: 1,
        onConfirmByCode: {
          449: async () => {
            if (!zoneId) return;
            await refreshList();
          }
        }
      });
      if (response?.Data?.ResponseCode === 200) {
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        console.error("CheckInForGuestUser_api() failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling checkIncheckOutForInvitation:", error);
    } finally {
      ShowHideModels(false);
      //setShowAlldayPostEventModal(false);
      //resetValues();
      setIsLoading(false);
    }
  };

  const SpotTakenButtonForInvitation = ({ zoneId, bookingDateStr }) => (
    <div >
      <div className="d-flex justify-content-between align-items-center ">
        <button className="main-btn fill-red-btn w-100" href="#"
          onClick={(e) => {
            e.preventDefault();
            if (!isLoading) {
              //ShowHideModels(false);
              //setShowAlldayPostEventModal(false);
              setShowPostEventModal(false);
              setShowMyInvitationEventModal(false);
              setShowReportParkingViolationModalForInv(true);
            }
          }}
        >
          <img src={Images.ExclamationCircle} alt="" className="img-fluid" />
          <span>{t("react_spot_taken")}</span>

        </button>
      </div>
    </div>
  );
  const ReportParkingViolationModalForInvitation = ({ zoneId }) => {

    const [plateNo, setPlateNo] = useState("");
    const [plateError, setPlateError] = useState("");
    const {
      bookingDate,
      spotId,
      bookingPeriod,
      bookingStartTime,
      bookingEndTime,
      spotName,
      guestUserId,
    } = selectedEvent;
    const bookingDateStr = bookingDate;
    let titleText = `${t("react_is_someone_already_parked")}`;
    return (
      <>
        <div id="divReportParkingViolationModal">
          <div
            className="modal ctm-modalscroll-modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
              <div className="modal-content modal-radius">
                <div className="modal-body">
                  <div className="ctm-modal-header">
                    <div className="close-modal">
                      <a onClick={(e) => {
                        e.preventDefault();
                        setShowReportParkingViolationModalForInv(false);
                      }}>
                        <img src={Images.Close} aria-label="Close" className="img-fluid" />
                      </a>
                    </div>

                    <div className="pt-4 text-center px-4">
                      <h5 className="popup-title text-red pb-0">{titleText} <span>{spotName}?</span></h5>
                    </div>

                    <div className="divider-line mt-3"></div>
                  </div>
                  <div className="modal-des">
                    <div className="modal-scroll-inner">
                      <div className="text-center">
                        <p>{t("react_enter_license_plate_number")}</p>
                      </div>
                      <div>

                        <div className="form-row">
                          <label className="popup-inner-title m-0">{t("license_plate_offender")}*</label>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            value={plateNo}
                            onChange={(e) => {
                              setPlateNo(e.target.value);
                              setPlateError("");
                            }}
                          />
                          {plateError && (
                            <div className="error-text">
                              <img src={Images.ErrorMsg} alt="" />
                              <p>{plateError}</p>
                            </div>
                          )}
                        </div>
                        <div className="text-center">
                          <p>{t("react_parking_violation_notification")}</p>
                        </div>
                      </div >
                    </div></div>
                  <div className="ctm-modal-footer">
                    <button className="main-btn fill-red-btn w-100" href="#"
                      onClick={async (e) => {
                        e.preventDefault();
                        if (!plateNo.trim()) {
                          setPlateError(t("react_vehicle_number_plate"));
                          return;
                        }

                        setShowReportParkingViolationModalForInv(false);
                        if (!isLoading) {
                          await ParkingViolationReportingForInvitation(zoneId, plateNo, spotId, spotName, bookingPeriod, guestUserId);
                        }
                      }}
                    >{t("react_send_to_parking_management")}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  const AlternateParkingSpotModalForInvitation = ({ event, zoneId }) => {

    let titleText = `${t("react_parking_violation_reported")}`;
    let topContainerText = "";
    let bottomContainerText = "";
    let btnTxt = "";
    // True on exactly the screens whose primary button reads "Yes, take this space" -
    // i.e. an alternate space is actually being offered. Set beside btnTxt so the label
    // and the Cancel button below cannot drift apart.
    //
    // Screen 1 sets that label regardless of SpotId, so the old `SpotId > 0` gate hid
    // Cancel on a Screen 1 response carrying SpotId 0 - the reported bug.
    let isAlternateSpaceOffer = false;
    let availableSpotName = "";
    const {
      zoneName
    } = selectedEvent;
    console.log(" parkingViolationReportingDataForInv--", parkingViolationReportingDataForInv);
    if (parkingViolationReportingDataForInv) {
      if (parkingViolationReportingDataForInv?.Screen === 1) {
        topContainerText = `${t("react_vehicle_parked_wrong_space")}`;
        bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingDataForInv?.Records?.ZoneName}:`;
        availableSpotName = parkingViolationReportingDataForInv?.Records?.SpotName;
        btnTxt = `${t("react_yes_take_this_space")}`;
        isAlternateSpaceOffer = true;
      }
      else if (parkingViolationReportingDataForInv?.Screen === 2) {
        topContainerText = `${t("react_parking_violation_reported")}`;
        bottomContainerText = `${t("no_parking_space_available")}`;
        btnTxt = t("confirm");

      }
      else if (parkingViolationReportingDataForInv?.Screen === 3) {
        if (parkingViolationReportingDataForInv?.Records?.SpotId === 0) {
          topContainerText = `${t("react_vehicle_not_registered")}`;
          bottomContainerText = `${t("no_parking_space_available")}`;
          btnTxt = t("confirm");

        }
        else if (parkingViolationReportingDataForInv?.Records?.SpotId > 0) {
          topContainerText = `${t("react_vehicle_not_registered")}`;
          bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingDataForInv?.Records?.ZoneName}:`;
          btnTxt = `${t("react_yes_take_this_space")}`;
          availableSpotName = parkingViolationReportingDataForInv?.Records?.SpotName;
          isAlternateSpaceOffer = true;
        }
      }
    }
    else return null;

    return (
      <>
        <div id="divAlternateParkingSpotModal">
          <div
            className="modal ctm-modalscroll-modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
              <div className="modal-content modal-radius">
                <div className="modal-body">
                  <div className="ctm-modal-header">
                    <div className="close-modal">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          setShowAlternateParkingSpotModalForInv(false);
                        }}
                      >
                        <img src={Images.Close} aria-label="Close" className="img-fluid" />
                      </a>
                    </div>

                    <div className="pt-4 text-center">
                      <h5 className="popup-title pe-3 pb-0">{titleText}</h5>
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <img src={Images.Participant} className="img-fluid" />
                        <h4>{parkingViolationReportingDataForInv?.Records?.PlateNo}</h4>
                      </div>
                    </div>

                    <div className="pt-1 text-center">
                      <p>{topContainerText}</p>
                    </div>
                    <div className="divider-line mt-3"></div>
                  </div>
                  <div className="modal-des">
                    <div className="modal-scroll-inner">
                      <div className="text-center my-34">
                        <img src={Images.ParkingBooking} className="img-fluid" alt="Parking Booking" />
                      </div>

                      <div className="text-center">

                        <p>{bottomContainerText}
                          <h5 className="color-green d-block mt-2 mb-0">{availableSpotName ? availableSpotName : ""}</h5></p>

                      </div >
                    </div></div>
                  <div className="ctm-modal-footer">
                    <button className="main-btn fill-green-btn w-100" href="#"
                      onClick={async (e) => {
                        e.preventDefault();
                        if (!isLoading) {
                          setShowAlternateParkingSpotModalForInv(false);
                          if (parkingViolationReportingDataForInv?.Records?.SpotId > 0) {
                            await AlternateParkingSpotBookingForInvitation(zoneId);
                          }
                        }
                      }}
                    >{btnTxt}</button>
                    {/* Mirrors AlternateParkingSpotModal above; this copy never had it. */}
                    {(isAlternateSpaceOffer || parkingViolationReportingDataForInv?.Records?.SpotId > 0) && (
                      <div className="d-block w-100">
                        <a
                          href="#"
                          className="main-btn cancel-btn gap-2"
                          onClick={(e) => {
                            e.preventDefault();
                            if (!isLoading) {
                              setShowAlternateParkingSpotModalForInv(false);
                            }
                          }}
                        >
                          <span> {t("cancel")}</span>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  async function ParkingViolationReportingForInvitation(zoneId, plateNoStr, spotIdStr, spotNameStr, bookingPeriodStr, guestUserId) {
    console.log(
      `ParkingViolationReportingForInvitation Clicked: ZoneId=${zoneId}, SpotId=${spotIdStr}, SpotName=${spotNameStr}`
    );

    try {
      if (isLoading) return;
      setIsLoading(true);
      const spotViolationTypeStr = bookingPeriodStr === 2 ? 1 : 0;
      // RON-1840: the API rejects numeric ids here - Postman only succeeds with
      // strings, and a numeric payload comes back as a 500 with no CORS headers,
      // which the browser surfaces as a bare network failure. `?? ""` keeps a
      // missing id as "" rather than the string "undefined".
      const reqParams = {
        ZoneId: String(zoneId ?? ""),
        PlateNo: plateNoStr,
        SpotViolationType: String(spotViolationTypeStr),
        SpotId: String(spotIdStr ?? ""),
        SpotName: spotNameStr,
        Tags: "",
        GuestUserId: guestUserId,
      };

      const response = await ReportParkingViolationForGuest_api(reqParams);
      console.log("ReportParkingViolationForGuest_api response:", response);

      if (response && response.Data?.ResponseCode === 200) {
        console.log("Parking violation of Invitations reported successfully.", response.Data);
        setParkingViolationReportingDataForInv(response.Data);
        console.log("parkingViolationReportingDataForInv-->", parkingViolationReportingDataForInv);
        //resetValues();
        setShowReportParkingViolationModalForInv(false);
        setShowAlternateParkingSpotModalForInv(true);
      } else {
        setNotification({
          type: "error",
          title: "Error",
          message: response?.Data?.ErrorMessage || t("something_went_wrong")
        });
        console.error("ReportParkingViolation_api failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling ReportParkingViolation_api:", error);
    } finally {
      setIsLoading(false);
    }
  }

  async function AlternateParkingSpotBookingForInvitation(zoneId) {
    if (!parkingViolationReportingDataForInv) return;

    try {

      setIsLoading(true);
      // Alternate zone returned by ReportParkingViolationForGuest_api (RON-5587)
      const alternateZoneId = parkingViolationReportingDataForInv?.Records?.AlternateZoneId;
      const reqParams = {
        ViolatedSpotId: parkingViolationReportingDataForInv?.Records?.ViolatedSpotId,
        SpotId: parkingViolationReportingDataForInv?.Records?.SpotId,
        ZoneId: zoneId,
        AlternateZoneId: alternateZoneId,
        Tags: "0",
        BookingId: parkingViolationReportingDataForInv?.Records?.BookingId,
        StartTime: parkingViolationReportingDataForInv?.Records?.StartTime,
        EndTime: parkingViolationReportingDataForInv?.Records?.EndTime,
        NewBookingPeriod: parkingViolationReportingDataForInv?.Records?.NewBookingPeriod,
      };

      const response = await GetAlternateParkingSpotForGuest_api(reqParams);
      console.log("GetAlternateParkingSpotForGuest_api response:", response);
      /* handleApiResponse(response, setNotification, t, {
        successMsg: 1,
        errorMsg: 1
      }); */
      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });
      if (response && response.Data?.ResponseCode === 200) {
        setShowAlternateParkingSpotModalForInv(false);
        await delay(1500);
        resetValues();
        await refreshList();
      } else {
        console.error("AlternateParkingSpotBookingForInvitation failed:", response?.Data?.ResponseMessage);
      }
    } catch (error) {
      console.error("Error calling GetAlternateParkingSpotForGuest_api:", error);
    } finally {
      setIsLoading(false);
    }
  }
  // My Invitation UI Component - End here...
  const headerTitle = t("react_hi").replace("%s", getFirstName());
  console.log("creditSystemStatus -->", creditSystemStatus);
  return (
    <div className='content-area'>
      <div className='my-booking-page' >

        {/* <Header /> */}
        <header className="header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-3">
                <div className="greeting-title">
                  <p>{headerTitle}</p>
                </div>
              </div>
              <div className="col-md-6"></div>
              <div className="col-md-3">
                <div className="menu-bar-options d-flex justify-content-end gap-3">
                  {zoneCreditValue !== 0 && (
                    <CreditInfoCard
                      userZoneCreditValue={zoneCreditValue}
                      userZoneCreditBalance={userCredit}
                      creditBalanceRefillEvery={creditBalanceRefill}
                      IsThumbnailPresent={isThumbnailPresent}
                      CompanyId={companyId}
                    />)}
                  <div className="notification-info">
                    <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                      <img src={Images.notification} alt="" className="img-fluid" />{hasUnreadNotifications && (
                        <span className="orange-dot"></span>
                      )}</a>
                  </div>
                  <NotificationPanel onUnreadChange={setHasUnreadNotifications} />
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="component-area">
          <div
            id="preloader"
            style={{
              display: isInitialLoading || isLoading ? "flex" : "none"
            }}
          >
            <img src={Images.LoaderFull} alt="" className="img-fluid" />
          </div>

          <Sidebar
            IsThumbnailPresent={isThumbnailPresent}
            CompanyId={companyId}
          />
          <div className="pt-96 pb-96 my-container active-cont">
            <div className="container">
              <div className="row mt-md-4 mt-85 plr-40">
                <div className="col-md-12">

                  <div className="module-heading-part d-flex gap-5 align-items-center mb-3">
                    {/* <h2 className="module-title">My bookings</h2> */}
                    <div className="home-dropdown">
                      {allowInvitations ? (
                        <CustomSearchableDropdown
                          items={bookingTypeOptions}
                          value={bookingType}
                          labelKey="name"
                          valueKey="id"
                          rootClassName="my-booking-dropdown"
                          searchable={false}
                          onChange={(value) => {
                            const bookingTypeValue = Number(value);

                            setBookingType(bookingTypeValue);

                            if (bookingTypeValue !== 0) {
                              resetValues();
                            }
                          }}
                        />
                      ) : (
                        <h2 className="module-title">{t("react_my_bookings")}</h2>
                      )}
                    </div>
                    {totalBookings > 0 && (
                      <p className="total-count">
                        {formatReactString(
                          t(totalBookings === 1 ? "react_booking" : "react_bookings"),
                          [totalBookings]
                        )}
                      </p>
                    )}
                  </div>

                  {isInitialLoading ? (
                    <div className="table-container position-relative gridtable">
                      <table className="table-details table-hover">
                        <tbody ref={bookingTableBodyRef} onScroll={handleTableScroll}>
                          <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>
                              {t("loading")}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ) : bookingData.length > 0 ? (
                    <div className="table-container position-relative gridtable">
                      <table className="table-details table-hover">
                        <thead>
                          <tr>
                            <th>{t("date")}</th>
                            <th>{t("time")}</th>
                            <th>{t("react_new_booking_spot")}</th>
                            <th>{t("zone")}</th>
                            <th>{t("react_details")}</th>
                          </tr>
                        </thead>
                        <tbody ref={bookingTableBodyRef} onScroll={handleTableScroll}>
                          {bookingData.map((booking, index) => (
                            <tr key={index}
                              className={booking.DisablePastBooking === 1 ? "no-hover" : ""}
                              onClick={booking.DisablePastBooking !== 1 ? () => handleRowClick(booking) : undefined}
                              style={{ cursor: booking.DisablePastBooking !== 1 ? "pointer" : "default" }}>
                              <td>
                                <span>
                                  {(() => {
                                    // parseLocalDate, not new Date(): "YYYY-MM-DD" as UTC midnight is the
                                    // previous day in UTC− timezones, so today's row missed "Today".
                                    const bookingDate = parseLocalDate(booking.BookingDate);
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);

                                    const tomorrow = new Date(today);
                                    tomorrow.setDate(tomorrow.getDate() + 1);

                                    bookingDate.setHours(0, 0, 0, 0);

                                    if (bookingDate.getTime() === today.getTime()) {
                                      return t("today");
                                    }

                                    if (bookingDate.getTime() === tomorrow.getTime()) {
                                      return t("tomorrow");
                                    }

                                    return formatDateToEEEddMMM(booking.BookingDate);
                                  })()}
                                </span></td>
                              <td>
                                <span>
                                  {booking.BookingStartTime && booking.BookingEndTime ? `${booking.BookingStartTime} - ${booking.BookingEndTime}` : t("all_day")}
                                </span></td>

                              <td>
                                <div className="name-with-icon">
                                  {booking.ZoneType == 1 ? (
                                    <>
                                      <img src={greenCar} alt="" className="img-fluid" />
                                    </>
                                  ) : booking.IsMeeting == 1 ? (
                                    <>
                                      <img src={greenRoom} alt="" className="img-fluid" />
                                    </>
                                  ) : (
                                    <>
                                      <img src={greenChair} alt="" className="img-fluid" />
                                    </>
                                  )}

                                  {booking.SpotName}
                                </div>
                              </td>
                              <td>{booking.ZoneName}</td>
                              <td>{getBookingDetailsText(booking)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <img src={NodataCalendar} className="img-fluid ms-5 ps-4" />
                      <p>{t("react_no_bookings_found")}</p>
                      <img
                        src={expandedLogoUrl || logo}
                        alt="Company logo"
                        className="img-fluid mt-2"
                        style={{ maxWidth: "220px" }}
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = logo;
                        }}
                      />
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPostEventModal && selectedEvent && (
        <PostEventModal
          onClose={() => setShowPostEventModal(false)}
        />
      )}

      {/* Cancel All day & Hourly Bookings */}
      {showCancelConfirm && (
        <CancelBookingConfirmation
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowCancelConfirm(false)}
        />
      )}

      {/* Cancel Meeting Modal */}
      {showCancelMeetingModal && (
        <CancelMeetingModal
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowCancelMeetingModal(false)}
        />
      )}
      {showCancelMeetingDateSelectModal && (
        <CancelMeetingDateSelectModal
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowCancelMeetingDateSelectModal(false)}
        />
      )}
      {/* Decline Meeting Modal */}
      {showDeclineMeetingModal && (
        <DeclineMeetingModal
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowDeclineMeetingModal(false)}
        />
      )}
      {showDeclineMeetingDateSelectModal && (
        <DeclineMeetingDateSelectModal
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowDeclineMeetingDateSelectModal(false)}
        />
      )}

      {/* Models belongs to Spot Taken */}
      {showReportParkingViolationModal && (
        <ReportParkingViolationModal
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowReportParkingViolationModal(false)}
        />
      )}
      {showAlternateParkingSpotModal && (
        <AlternateParkingSpotModal
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowAlternateParkingSpotModal(false)}
        />
      )}


      {/* Edit Meeting Modal (RON-5375) — reuses the 3-step NewMeetingModal in edit mode */}
      {showEditMeetingModal && selectedEvent && (
        <NewMeetingModal
          // keyed on the edit type so "Open series" (3 -> 1) remounts a fresh modal
          key={`edit-meeting-${editRescheduleType}`}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          show={true}
          mode="edit"
          editMeetingId={selectedEvent.meetingId}
          rescheduleType={editRescheduleType}
          onOpenSeries={() => setEditRescheduleType(1)}
          date={selectedEvent.bookingDate}
          selectedZone={selectedEvent.zoneId}
          mapType={selectedEvent.mapType}
          navSpotId={selectedEvent.spotId}
          setNotification={setNotification}
          onClose={() => setShowEditMeetingModal(false)}
          onConfirm={() => fetchData(1)}
          onMeetingCreated={() => fetchData(1)}
          setShowScheduleMeetingModal={setShowEditMeetingModal}
        />
      )}

      {/* Reschedule Meeting Modal */}
      {showRescheduleMeetingModal && (
        <ReScheduleMeetingModal
          selectedZoneId={selectedZoneId}
          event={selectedEvent}
          rescheduledBookingOccurrence={rescheduledBookingOccurrence}
          setRescheduledBookingOccurrence={setRescheduledBookingOccurrence}
          selectedRescheduleDate={selectedRescheduleDate}
          setSelectedRescheduleDate={setSelectedRescheduleDate}
          setShowReScheduleMeetingDateSelectModal={setShowReScheduleMeetingDateSelectModal}
        />
      )}
      {showReScheduleMeetingDateSelectModal && (
        <ReScheduleMeetingDateSelectModal
          event={selectedEvent}
          onDateSelect={(dateStr) => {
            setSelectedRescheduleDate(dateStr);
            setShowReScheduleMeetingDateSelectModal(false);
            setShowRescheduleMeetingModal(true);
          }}
        />
      )}
      {(notification && !isLoading) && (
        <NotificationMessage
          type={notification.type}
          title={notification.title}
          message={notification.message}
          duration={6000}
          onClose={() => setNotification(null)}
        />
      )}

      {/* Models belongs to My Invitation- start here... */}

      {showMyInvitationEventModal && selectedEvent && (
        <MyInvitationEventModal
          onClose={() => setShowMyInvitationEventModal(false)}
        />
      )}

      {/* Models belongs to Spot Taken */}
      {showReportParkingViolationModalForInv && (
        <ReportParkingViolationModalForInvitation
          zoneId={selectedZoneId}
          event={selectedEvent}
          onClose={() => setShowReportParkingViolationModalForInv(false)}
        />
      )}
      {showAlternateParkingSpotModalForInv && (
        <AlternateParkingSpotModalForInvitation
          zoneId={selectedZoneId}
          onClose={() => setShowAlternateParkingSpotModalForInv(false)}
        />
      )}

      {/* Models belongs to My Invitation- end here... */}
      {renderApiUi(isLoading)}
    </div>

  );

}
export const useBookingContext = (clickedFullDay, weekData) => {
  const bookingDateStr = useMemo(
    () => getBookingDateStr(clickedFullDay),
    [clickedFullDay]
  );

  const weekKey = useMemo(
    () => getWeekKey(clickedFullDay),
    [clickedFullDay]
  );

  const bookingForModal = useMemo(() => {
    if (!bookingDateStr) return null;

    if (weekKey && weekData?.[weekKey]) {
      return (
        weekData[weekKey].find(
          b => b.BookingDate === bookingDateStr
        ) || null
      );
    }

    return (
      weekData?.find(
        b => b.BookingDate === bookingDateStr
      ) || null
    );
  }, [weekKey, weekData, bookingDateStr]);

  return { bookingDateStr, weekKey, bookingForModal };
};

export const useBookingDisplayDate = (clickedFullDay, setSelectedDay) => {
  // parseLocalDate, not new Date(): "YYYY-MM-DD" as UTC midnight is the previous day in UTC− zones.
  const bookingDate = clickedFullDay ? parseLocalDate(clickedFullDay) : null;

  const displayMonth = bookingDate
    ? bookingDate.toLocaleDateString("en-US", { month: "long" })
    : "";

  const displayYear = bookingDate
    ? bookingDate.getFullYear()
    : "";

  useEffect(() => {
    if (!bookingDate) return;
    setSelectedDay(bookingDate.getDate());
  }, [bookingDate, setSelectedDay]);

  return { bookingDate, displayMonth, displayYear };

};


